webpackJsonp([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(974);


/***/ },

/***/ 21:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderShallowEqual = __webpack_require__(83);
	
	var _reactPureRenderShallowEqual2 = _interopRequireDefault(_reactPureRenderShallowEqual);
	
	/**
	 * Purified React.Component. Goodness.
	 * http://facebook.github.io/react/docs/advanced-performance.html
	 */
	
	var Component = (function (_React$Component) {
	  _inherits(Component, _React$Component);
	
	  function Component() {
	    _classCallCheck(this, Component);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	
	    var shouldUpdate = !_reactPureRenderShallowEqual2['default'](this.props, nextProps) || !_reactPureRenderShallowEqual2['default'](this.state, nextState);
	
	    return shouldUpdate;
	  };
	
	  return Component;
	})(_react2['default'].Component);
	
	exports['default'] = Component;
	module.exports = exports['default'];

/***/ },

/***/ 38:
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var Constants = {
		INVOICE_STATUS: {
			NEW: 1,
			PAYED: 2
		}
	};
	
	exports["default"] = Constants;
	module.exports = exports["default"];

/***/ },

/***/ 43:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	var _constants = __webpack_require__(38);
	
	var c = _interopRequireWildcard(_constants);
	
	var DbInfo = (function (_Array) {
		_inherits(DbInfo, _Array);
	
		function DbInfo(arr) {
			var _this = this;
	
			_classCallCheck(this, DbInfo);
	
			_Array.call(this);
			arr.forEach(function (item) {
				return _this.push(item);
			});
		}
	
		DbInfo.prototype.get = function get(id) {
			for (var i = 0; i < this.length; i++) {
				if (this[i].id == id) {
					return this[i].title;
				}
			}
		};
	
		DbInfo.prototype.getItem = function getItem(id) {
			for (var i = 0; i < this.length; i++) {
				if (this[i].id == id) {
					return this[i];
				}
			}
		};
	
		DbInfo.prototype.asArray = function asArray() {
			var _this2 = this;
	
			var arr = [];
	
			var _loop = function () {
				var keys = _Object$keys(_this2[i]);
				var o = {};
				keys.forEach(function (key) {
					o[key] = _this2[i][key];
				});
				arr.push(o);
			};
	
			for (var i = 0; i < this.length; i++) {
				_loop();
			}
			return arr;
		};
	
		return DbInfo;
	})(Array);
	
	var DbInfos = {};
	
	DbInfos.YesNo = new DbInfo([{ id: 1, title: 'Ano' }, { id: 0, title: 'Ne' }]);
	
	DbInfos.InvoiceStatus = new DbInfo([{ id: c.INVOICE_STATUS.NEW, title: 'vystaveno' }, { id: c.INVOICE_STATUS.PAYED, title: 'zaplaceno' }]);
	
	DbInfos.TicketStatus = new DbInfo([{ id: 1, title: 'nový' }, { id: 2, title: 'k analýze' }, { id: 3, title: 'řeší se' }, { id: 4, title: 'hotovo' }]);
	
	module.exports = DbInfos;

/***/ },

/***/ 79:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _eventemitter3 = __webpack_require__(300);
	
	var _eventemitter32 = _interopRequireDefault(_eventemitter3);
	
	var eventEmitter = new _eventemitter32['default']();
	exports['default'] = eventEmitter;
	module.exports = exports['default'];

/***/ },

/***/ 87:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(20);
	
	var _utilsUtils = __webpack_require__(247);
	
	var _components = {
		_$Datagrid: {
			displayName: 'Datagrid'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Datagrid = (function (_React$Component) {
		_inherits(Datagrid, _React$Component);
	
		function Datagrid() {
			_classCallCheck(this, _Datagrid);
	
			_React$Component.apply(this, arguments);
		}
	
		Datagrid.prototype.refresh = function refresh() {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
	
		Datagrid.prototype.getLines = function getLines() {
			var lines = Math.round((_utilsUtils.getWindowSize().height - 260) / 30);
			if (lines < 16) {
				lines = 16;
			}
			if (this.props.limit) {
				lines = this.props.limit;
			}
			return lines;
		};
	
		Datagrid.prototype.render = function render() {
			var _this = this;
	
			var loading = this.props.state && this.props.state.get('pending') ? 'rotate' : '';
	
			var filters = this.props.filters ? this.props.filters.map(function (name) {
				return _react2['default'].createElement(_reactisDatagrid.FilterField, { key: name, filter: _this.props.filter, field: name, style: { marginLeft: 10, float: 'right' } });
			}).reverse() : false;
	
			var getRowClassName = function getRowClassName(row) {
				if (typeof row.active == 'undefined') {
					return;
				}
				return !row.active ? 'archive' : null;
			};
	
			return _react2['default'].createElement(
				'div',
				null,
				!this.props.disableButtons && _react2['default'].createElement(
					'div',
					{ className: 'dgtoolbar vp-tablet' },
					filters,
					_react2['default'].createElement(
						_reactBootstrap.Button,
						{ onClick: function () {
								return _this.refresh();
							}, title: this.props.alt, style: { float: 'right', marginRight: 0 } },
						_react2['default'].createElement('i', { className: 'fa fa-refresh ' + loading, style: { fontSize: 15 } })
					),
					this.props.buttons,
					_react2['default'].createElement('div', { className: 'clearfix' })
				),
				_react2['default'].createElement(_reactisDatagrid.RxDatagrid, _extends({ ref: 'datagrid',
					getRowClassName: getRowClassName
				}, this.props, {
					compact: _utilsUtils.getWindowSize().width < 700,
					limit: this.getLines() }))
			);
		};
	
		_createClass(Datagrid, null, [{
			key: 'defaultProps',
			value: {
				alt: 'Obnovit',
				disableButtons: false
			},
			enumerable: true
		}]);
	
		var _Datagrid = Datagrid;
		Datagrid = _wrapComponent('_$Datagrid')(Datagrid) || Datagrid;
		Datagrid = _reactRedux.connect(function (state, ownProps) {
			return {
				state: state.datagrids.get(ownProps.id)
			};
		}, null, null, { withRef: true })(Datagrid) || Datagrid;
		return Datagrid;
	})(_react2['default'].Component);
	
	exports['default'] = Datagrid;
	module.exports = exports['default'];

/***/ },

/***/ 88:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _components = {
		_$ActiveSelect: {
			displayName: 'ActiveSelect'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var ActiveSelect = (function (_Component) {
		_inherits(ActiveSelect, _Component);
	
		function ActiveSelect() {
			_classCallCheck(this, _ActiveSelect);
	
			_Component.apply(this, arguments);
		}
	
		ActiveSelect.prototype.render = function render() {
	
			var options = [{ id: 1, title: 'Aktivní' }, { id: 2, title: 'Archiv' }, { id: 3, title: 'Vše' }];
	
			return _react2['default'].createElement(_reactisInputs.Select, _extends({}, this.props, {
				style: { width: 100, display: 'block' },
				clearable: false,
				options: options
			}));
		};
	
		var _ActiveSelect = ActiveSelect;
		ActiveSelect = _wrapComponent('_$ActiveSelect')(ActiveSelect) || ActiveSelect;
		return ActiveSelect;
	})(_Component2['default']);
	
	exports['default'] = ActiveSelect;
	module.exports = exports['default'];

/***/ },

/***/ 89:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _helpersApiClient = __webpack_require__(168);
	
	var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Lookup = __webpack_require__(502);
	
	var _Lookup2 = _interopRequireDefault(_Lookup);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = {
		_$ClientLookup: {
			displayName: 'ClientLookup'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var ClientLookup = (function (_Component) {
		_inherits(ClientLookup, _Component);
	
		function ClientLookup() {
			_classCallCheck(this, _ClientLookup);
	
			_Component.apply(this, arguments);
		}
	
		ClientLookup.prototype.api = function api(q, page) {
			var client = new _helpersApiClient2['default']();
			return client.call('client.lookup', { q: q, page: page });
		};
	
		ClientLookup.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(_Lookup2['default'], _extends({ query: function (q, page) {
					return _this.api(q, page);
				} }, this.props));
		};
	
		var _ClientLookup = ClientLookup;
		ClientLookup = _wrapComponent('_$ClientLookup')(ClientLookup) || ClientLookup;
		return ClientLookup;
	})(_Component2['default']);
	
	exports['default'] = ClientLookup;
	module.exports = exports['default'];

/***/ },

/***/ 90:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	//require('moment/locale/cs');
	
	var _components = {
		_$DateRange: {
			displayName: 'DateRange'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var React = __webpack_require__(1);
	var classnames = __webpack_require__(7);
	var DateRangePicker = __webpack_require__(810);
	var PureRenderMixin = __webpack_require__(808);
	var Picker = _wrapComponent('_$DateRange')(React.createClass({ displayName: 'DateRange',
	
		mixins: [PureRenderMixin],
	
		getInitialState: function getInitialState() {
			return {
				value: this.fixValue(this.props.value)
			};
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				time: false
			};
		},
	
		fixValue: function fixValue(val) {
			if (val) {
				var start = _moment2['default'](val.startDate);
				var end = _moment2['default'](val.endDate);
				return {
					startDate: start,
					endDate: end
				};
			}
			return null;
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			this.setState({ value: this.fixValue(nextProps.value) });
		},
	
		getValue: function getValue() {
			return this.state.value;
		},
	
		renderFormGroup: function renderFormGroup(children) {
			var classes = {
				'form-group': false,
				'has-feedback': this.props.hasFeedback,
				'has-success': this.props.bsStyle === 'success',
				'has-warning': this.props.bsStyle === 'warning',
				'has-error': this.props.bsStyle === 'error'
			};
			classes[this.props.groupClassName] = this.props.groupClassName;
	
			return React.createElement("div", { className: classnames(classes) }, children);
		},
	
		renderError: function renderError() {
			return this.props.error ? React.createElement("span", { className: "error-block", key: "error" }, this.props.error) : null;
		},
	
		renderWrapper: function renderWrapper(children) {
			return this.props.wrapperClassName ? React.createElement("div", { className: this.props.wrapperClassName, key: "wrapper" }, children) : children;
		},
	
		onApply: function onApply(e, picker) {
			var _this = this;
	
			var value = {
				startDate: picker.startDate,
				endDate: picker.endDate
			};
			this.setState({ value: value }, function () {
				return _this.handleChange();
			});
		},
	
		handleChange: function handleChange(e) {
			if (this.props.onChange) {
				this.props.onChange(this.state.value);
			}
			if (this.props.onBlur) {
				this.props.onBlur(this.state.value);
			}
		},
	
		onCancel: function onCancel(e, p) {
			var _this2 = this;
	
			this.setState({ value: null }, function () {
				return _this2.handleChange();
			});
		},
	
		render: function render() {
	
			_moment2['default'].locale('cs');
			var locale = {
				format: 'DD.MM.YYYY',
				separator: ' - ',
				applyLabel: 'OK',
				cancelLabel: 'Zrušit výběr',
				fromLabel: 'Od',
				toLabel: 'Do',
				weekLabel: 'T',
				customRangeLabel: 'Vlastní rozsah',
				daysOfWeek: _moment2['default'].weekdaysMin(),
				monthNames: _moment2['default'].monthsShort(),
				firstDay: _moment2['default'].localeData()._week.dow
			};
	
			var ranges = {
				'Dnes': [_moment2['default'](), _moment2['default']()],
				'Včera': [_moment2['default']().subtract(1, 'days'), _moment2['default']().subtract(1, 'days')],
				'Tento týden': [_moment2['default']().startOf('isoweek'), _moment2['default']()],
				'Tento měsíc': [_moment2['default']().startOf('month'), _moment2['default']().endOf('month')],
				'Minulý měsíc': [_moment2['default']().subtract(1, 'month').startOf('month'), _moment2['default']().subtract(1, 'month').endOf('month')]
			};
	
			var label = '';
			if (this.state.value) {
				var s = _moment2['default'](this.state.value.startDate);
				var start = s.format('D.M.');
				var e = _moment2['default'](this.state.value.endDate);
				var end = e.format('D.M.');
				label = start + ' - ' + end;
				if (s.format('D.M.YYYY') === e.format('D.M.YYYY')) {
					label = s.format('D.M.YYYY');
				}
			}
	
			//var { onBlur, ...other } = this.props;
			return this.renderFormGroup([this.renderWrapper([React.createElement(
				DateRangePicker,
				{ onApply: this.onApply, onCancel: this.onCancel, ranges: ranges,
					startDate: this.state.value ? this.state.value.startDate : _moment2['default'](),
					endDate: this.state.value ? this.state.value.endDate : _moment2['default'](),
					locale: locale, opens: this.props.opens },
				React.createElement(
					_reactBootstrap.Button,
					{ className: 'selected-date-range-btn', style: { width: '100%' } },
					React.createElement(
						'div',
						{ className: 'pull-left' },
						label
					),
					React.createElement(
						'div',
						{ className: 'pull-right' },
						React.createElement('span', { className: 'caret' })
					)
				)
			)]), this.renderError()]);
		}
	}));
	
	module.exports = Picker;

/***/ },

/***/ 91:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var FormDB = (function (_React$Component) {
		_inherits(FormDB, _React$Component);
	
		_createClass(FormDB, null, [{
			key: 'contextTypes',
			value: {
				store: _react2['default'].PropTypes.object,
				user: _react2['default'].PropTypes.object.isRequired
			},
			enumerable: true
		}]);
	
		function FormDB(props, context) {
			_classCallCheck(this, FormDB);
	
			_React$Component.call(this, props);
			this.changed = !props.id;
			this.title = false;
			this.user = context.user;
		}
	
		FormDB.prototype.componentDidMount = function componentDidMount() {
			if (!this.props.form || !this.props.form.get('loaded')) {
				this.load();
			}
		};
	
		FormDB.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
			if (nextProps.id != this.props.id || nextProps.tabid != this.props.tabid || nextProps.form != this.props.form) {
				return true;
			}
			return false;
		};
	
		FormDB.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			var newTab = {};
			if (nextProps.tab.title != this.title && this.title) {
				newTab.title = this.title;
			}
			if (nextProps.tab.unsave != this.changed) {
				newTab.unsave = this.changed;
			}
			if (_Object$keys(newTab).length > 0) {
				this.props.updateTab(newTab);
			}
		};
	
		FormDB.prototype.load = function load() {
			var _this = this;
	
			if (this.props.id) {
				this.props.actions.load('tab_' + this.props.tabid, this.api.fetch, { id: this.props.id }).then(function (a) {
					_this.changed = false;
					//this.form.storeCheckpoint();
					if (a.error && a.error.code == 404) {
						alert(_this.messages.notfound);
						_this.props.closeTab();
					} else {
						_this.updateTab(a.result);
					}
				});
			}
		};
	
		FormDB.prototype.getFormData = function getFormData() {
			return _extends({}, this.form.getValues().toJS(), { id: this.props.id });
		};
	
		FormDB.prototype.save = function save() {
			var _this2 = this;
	
			var close = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
			var errors = this.refs.form.getWrappedInstance().validate();
			if (errors) {
				this.displayErrors(errors);
			} else {
				var data = this.getFormData();
				this.props.actions.save('tab_' + this.props.tabid, this.api.save, data).then(function (action) {
					if (!action.error) {
						_this2.changed = false;
						_EventEmitter2['default'].emit(_this2.changeEvent);
						_this2.props.updateTab({ data: action.result.id, unsave: false });
						if (close) {
							_this2.props.closeTab();
						} else {
							_this2.forceUpdate();
						}
					} else {
						if (action.error.code == 1001) {
							var _errors = JSON.parse(action.error.message);
							_this2.displayErrors(_errors);
						}
					}
				});
			}
		};
	
		FormDB.prototype.remove = function remove() {
			var _this3 = this;
	
			var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.remove);
			confirm.show(this.context.store.dispatch, function () {
				_this3.props.actions.remove('tab_' + _this3.props.tabid, _this3.api.remove, { id: _this3.props.id }).then(function (action) {
					if (!action.error) {
						_EventEmitter2['default'].emit(_this3.changeEvent);
						_this3.props.closeTab();
					}
				});
			});
		};
	
		FormDB.prototype.archive = function archive() {
			var _this4 = this;
	
			var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.archive);
			confirm.show(this.context.store.dispatch, function () {
				_this4.props.actions.archive('tab_' + _this4.props.tabid, _this4.api.archive, { id: _this4.props.id }).then(function (action) {
					if (!action.error) {
						_EventEmitter2['default'].emit(_this4.changeEvent);
						_this4.props.closeTab();
					}
				});
			});
		};
	
		FormDB.prototype.active = function active() {
			var _this5 = this;
	
			var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.active);
			confirm.show(this.context.store.dispatch, function () {
				_this5.props.actions.active('tab_' + _this5.props.tabid, _this5.api.active, { id: _this5.props.id }).then(function (action) {
					if (!action.error) {
						_EventEmitter2['default'].emit(_this5.changeEvent);
					}
				});
			});
		};
	
		FormDB.prototype.displayErrors = function displayErrors(errors) {
			var messages = [];
			if (typeof errors != 'string') {
				_Object$keys(errors).forEach(function (key) {
					if (errors[key].childs) {
						errors[key].childs.forEach(function (child) {
							_Object$keys(child.errors).forEach(function (key2) {
								messages.push(child.errors[key2][0]);
							});
						});
					} else {
						messages.push(errors[key][0]);
					}
				});
			} else {
				messages.push(errors);
			}
			var alert = new _reactisModal.AlertWindow('Chyba formuláře', messages.map(function (m) {
				return _react2['default'].createElement(
					'span',
					{ key: m },
					m,
					_react2['default'].createElement('br', null)
				);
			}));
			alert.show(this.context.store.dispatch);
		};
	
		return FormDB;
	})(_react2['default'].Component);
	
	exports['default'] = FormDB;
	module.exports = exports['default'];

/***/ },

/***/ 92:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = {
		_$Toolbar: {
			displayName: 'Toolbar'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Toolbar = (function (_Component) {
		_inherits(Toolbar, _Component);
	
		function Toolbar() {
			_classCallCheck(this, _Toolbar);
	
			_Component.apply(this, arguments);
		}
	
		Toolbar.prototype.render = function render() {
			return _react2['default'].createElement(
				'div',
				{ className: 'formtoolbar' },
				this.props.buttons,
				_react2['default'].createElement(
					'h3',
					null,
					this.props.title.title ? this.props.title.title : this.props.title
				),
				this.props.title.subtitle && _react2['default'].createElement(
					'div',
					null,
					this.props.title.subtitle
				),
				_react2['default'].createElement('hr', null)
			);
		};
	
		var _Toolbar = Toolbar;
		Toolbar = _wrapComponent('_$Toolbar')(Toolbar) || Toolbar;
		return Toolbar;
	})(_Component2['default']);
	
	exports['default'] = Toolbar;
	module.exports = exports['default'];

/***/ },

/***/ 93:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _phpjs = __webpack_require__(802);
	
	var _phpjs2 = _interopRequireDefault(_phpjs);
	
	exports['default'] = {
	
		Date: function Date(value) {
			if (value) {
				return new _moment2['default'](value).format('D.M.YYYY');
			}
		},
	
		DateTime: function DateTime(value) {
			if (value) {
				return new _moment2['default'](value).format('D.M.YYYY H:mm');
			}
		},
	
		Time: function Time(value) {
			if (value) {
				return Math.floor(value / 60) + ':' + (value % 60 < 10 ? 0 : '') + value % 60;
			}
		},
	
		Number: function Number(value) {
			if (value !== null) {
				var match = ('' + value).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
				if (!match) {
					return _phpjs2['default'].number_format(value, 0, ',', ' ');
				}
				var places = Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
				return _phpjs2['default'].number_format(value, places, ',', ' ');
			}
		},
	
		Check: function Check(val) {
			var cn = val ? 'fa fa-check' : 'fa fa-close';
			return _react2['default'].createElement(
				'div',
				{ style: { textAlign: 'center' } },
				_react2['default'].createElement('span', { style: { color: '#444', fontSize: 13 }, className: cn })
			);
		},
	
		coloredCheck: function coloredCheck(val) {
			var cn = val ? 'fa fa-check' : 'fa fa-close';
			return _react2['default'].createElement(
				'div',
				{ style: { textAlign: 'center' } },
				_react2['default'].createElement('span', { style: { color: val ? '#484' : '#800', fontSize: 13 }, className: cn })
			);
		},
	
		DbInfo: function DbInfo(value) {
			var _this = this;
	
			if (typeof value !== 'undefined' || value !== null) {
				var v;
				_Object$keys(this).forEach(function (key) {
					if (_this[key].id == value) {
						v = _this[key].title;
					}
				});
				return v;
			}
		}
	};
	module.exports = exports['default'];

/***/ },

/***/ 105:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactisModal = __webpack_require__(29);
	
	var _components = {
		_$ActionButton: {
			displayName: 'ActionButton'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var ActionButton = (function (_Component) {
		_inherits(ActionButton, _Component);
	
		function ActionButton() {
			_classCallCheck(this, _ActionButton);
	
			_Component.apply(this, arguments);
		}
	
		ActionButton.prototype.handleClick = function handleClick() {
			if (!this.props.disabled) {
				this.props.onClick();
			} else {
				if (this.props.onDisabledClick) {
					this.props.onDisabledClick();
				}
				if (this.props.alert) {
					var _alert = new _reactisModal.AlertWindow('Oprávnění', this.props.alert);
					_alert.show(this.context.store.dispatch);
				}
			}
		};
	
		ActionButton.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_reactBootstrap.Button,
				{ bsStyle: this.props.bsStyle,
					className: _classnames2['default']({ 'input-group': true, disabled: this.props.disabled }),
					onClick: function () {
						return _this.handleClick();
					} },
				_react2['default'].createElement('i', { className: this.props.icon + ' position-left' }),
				this.props.children
			);
		};
	
		_createClass(ActionButton, null, [{
			key: 'defaultProps',
			value: {
				alert: 'Nemáte oprávnění akci provést!'
			},
			enumerable: true
		}, {
			key: 'contextTypes',
			value: {
				store: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _ActionButton = ActionButton;
		ActionButton = _wrapComponent('_$ActionButton')(ActionButton) || ActionButton;
		return ActionButton;
	})(_Component2['default']);
	
	exports['default'] = ActionButton;
	module.exports = exports['default'];

/***/ },

/***/ 106:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _Object$assign = __webpack_require__(172)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(19);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _ClosableTab = __webpack_require__(975);
	
	var _ClosableTab2 = _interopRequireDefault(_ClosableTab);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reduxModulesTabs = __webpack_require__(511);
	
	var actions = _interopRequireWildcard(_reduxModulesTabs);
	
	var _reactContextmenu = __webpack_require__(861);
	
	var _components = {
		_$TabFormContextMenu: {
			displayName: 'TabFormContextMenu'
		},
		_$TabListContextMenu: {
			displayName: 'TabListContextMenu'
		},
		_$TabbablePage: {
			displayName: 'TabbablePage'
		},
		_$Unknown: {
			isInFunction: true
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var TabFormContextMenu = (function (_React$Component) {
		_inherits(TabFormContextMenu, _React$Component);
	
		function TabFormContextMenu() {
			_classCallCheck(this, _TabFormContextMenu);
	
			_React$Component.apply(this, arguments);
		}
	
		TabFormContextMenu.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_reactContextmenu.ContextMenu,
				{ identifier: 'TabFormContextMenu', currentItem: this.currentItem },
				_react2['default'].createElement(
					_reactContextmenu.MenuItem,
					{ data: { close: 1 }, onSelect: function (data) {
							return _this.handleSelect(data);
						} },
					'Zavřít'
				),
				_react2['default'].createElement(
					_reactContextmenu.MenuItem,
					{ data: { close: 2 }, onSelect: function (data) {
							return _this.handleSelect(data);
						} },
					'Zavřít ostatní'
				),
				_react2['default'].createElement(
					_reactContextmenu.MenuItem,
					{ data: { close: 3 }, onSelect: function (data) {
							return _this.handleSelect(data);
						} },
					'Zavřít vše'
				)
			);
		};
	
		TabFormContextMenu.prototype.handleSelect = function handleSelect(data) {
			this.props.onSelect(data);
		};
	
		var _TabFormContextMenu = TabFormContextMenu;
		TabFormContextMenu = _wrapComponent('_$TabFormContextMenu')(TabFormContextMenu) || TabFormContextMenu;
		return TabFormContextMenu;
	})(_react2['default'].Component);
	
	var TabListContextMenu = (function (_React$Component2) {
		_inherits(TabListContextMenu, _React$Component2);
	
		function TabListContextMenu() {
			_classCallCheck(this, _TabListContextMenu);
	
			_React$Component2.apply(this, arguments);
		}
	
		TabListContextMenu.prototype.render = function render() {
			var _this2 = this;
	
			return _react2['default'].createElement(
				_reactContextmenu.ContextMenu,
				{ identifier: 'TabListContextMenu', currentItem: this.currentItem },
				_react2['default'].createElement(
					_reactContextmenu.MenuItem,
					{ data: { close: 3 }, onSelect: function (data) {
							return _this2.handleSelect(data);
						} },
					'Zavřít ostatní'
				)
			);
		};
	
		TabListContextMenu.prototype.handleSelect = function handleSelect(data) {
			this.props.onSelect(data);
		};
	
		var _TabListContextMenu = TabListContextMenu;
		TabListContextMenu = _wrapComponent('_$TabListContextMenu')(TabListContextMenu) || TabListContextMenu;
		return TabListContextMenu;
	})(_react2['default'].Component);
	
	var TabbablePage = (function (_React$Component3) {
		_inherits(TabbablePage, _React$Component3);
	
		function TabbablePage() {
			_classCallCheck(this, _TabbablePage);
	
			_React$Component3.apply(this, arguments);
		}
	
		TabbablePage.prototype.componentDidMount = function componentDidMount() {
			if (this.props.tabs.length == 0) {
				if (this.props.params.id) {
					if (parseInt(this.props.params.id) == 0) {
						this.handleNewTab();
					} else {
						this.props.actions.openTabForm(this.props.module, '...', { id: parseInt(this.props.params.id) });
					}
				}
			}
			if (typeof this.props.params.id === 'undefined' && this.props.selectedTab !== 0 && this.context.location.query && this.context.location.query.filter) {
				this.props.actions.selectTab(this.props.module, 0);
			}
		};
	
		TabbablePage.prototype.handleSelectTab = function handleSelectTab(key) {
			if (key == 'add') {
				this.handleNewTab();
			} else {
				var tab = this.props.tabs.filter(function (item) {
					return item.id == key;
				})[0];
				this.props.actions.selectTab(this.props.module, key);
			}
		};
	
		TabbablePage.prototype.handleNewTab = function handleNewTab() {
			var args = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
			var data = { id: 0, unsave: true };
			if (args) {
				_Object$assign(data, args);
			}
			this.props.actions.openTabForm(this.props.module, this.props.newTitle, data);
		};
	
		TabbablePage.prototype.handleSelectContextMenu = function handleSelectContextMenu(data) {
			if (data.close == 1) {
				this.props.actions.closeTab(this.props.module, data.id);
			}
			if (data.close == 2) {
				this.props.actions.closeOthersTab(this.props.module, data.id);
			}
			if (data.close == 3) {
				this.props.actions.closeAll(this.props.module);
			}
			if (data.reload) {
				this.refs['tab' + data.id].getWrappedInstance().load();
			}
		};
	
		TabbablePage.prototype.handleCloseTab = function handleCloseTab(id) {
			this.props.actions.closeTab(this.props.module, id);
		};
	
		TabbablePage.prototype.render = function render() {
			var _this3 = this;
	
			var cmlayer = _reactContextmenu.ContextMenuLayer("TabFormContextMenu", function (props) {
				return {
					id: props.id
				};
			});
			var cmlayer0 = _reactContextmenu.ContextMenuLayer("TabListContextMenu", function (props) {
				return {};
			});
			var TabMenu = cmlayer0(_wrapComponent('_$Unknown')(_react2['default'].createClass({
				render: function render() {
					return _react2['default'].createElement(
						'div',
						null,
						this.props.title
					);
				}
			})));
	
			var ClosableTabMenu = cmlayer(_ClosableTab2['default']);
	
			/*const TabMenu = (React.createClass({
	  	render() {
	  		return <div>{this.props.title}</div>
	  	}
	  }));*/
	
			var tabs = this.props.tabs.map(function (item) {
				var title = _react2['default'].createElement(ClosableTabMenu, {
					onClose: function (key) {
						return _this3.props.actions.closeTab(_this3.props.module, key);
					},
					id: item.id,
					title: item.title,
					unsave: item.unsave
				});
	
				return _react2['default'].createElement(
					_reactBootstrap.Tab,
					{ key: item.id, eventKey: item.id, title: title },
					_react2['default'].createElement(_this3.props.Form, {
						tabid: item.id,
						ref: 'tab' + item.id,
						id: item.data,
						tab: item,
						tabActions: _this3.props.actions,
						closeTab: function () {
							return _this3.handleCloseTab(item.id);
						},
						updateTab: function (tab) {
							return _this3.props.actions.updateTab(_this3.props.module, item.id, tab);
						}
					})
				);
			});
	
			return _react2['default'].createElement(
				'div',
				{ className: 'tdidocument tabbable tab-content-bordered' },
				_react2['default'].createElement(TabFormContextMenu, { onSelect: function (data) {
						return _this3.handleSelectContextMenu(data);
					} }),
				_react2['default'].createElement(TabListContextMenu, { onSelect: function (data) {
						return _this3.handleSelectContextMenu(data);
					} }),
				_react2['default'].createElement(
					_reactBootstrap.Tabs,
					{ onSelect: function (key) {
							return _this3.handleSelectTab(key);
						},
						activeKey: this.props.selectedTab,
						animation: false },
					_react2['default'].createElement(
						_reactBootstrap.Tab,
						{ eventKey: 0, title: _react2['default'].createElement(TabMenu, { title: this.props.listTitle }) },
						_react2['default'].createElement(this.props.List, { module: this.props.module,
							actions: this.props.actions,
							onNewTab: function (args) {
								return _this3.handleNewTab(args);
							} })
					),
					tabs,
					!this.props.disableAdd && _react2['default'].createElement(_reactBootstrap.Tab, { eventKey: 'add',
						title: _react2['default'].createElement(TabMenu, { title: _react2['default'].createElement(
								'span',
								null,
								_react2['default'].createElement('span', { className: 'icon-plus3', style: { fontSize: 12 } }),
								' ',
								_react2['default'].createElement(
									'span',
									{ className: 'show-phone' },
									'přidat'
								)
							) }) })
				)
			);
		};
	
		_createClass(TabbablePage, null, [{
			key: 'contextTypes',
			value: {
				history: _react2['default'].PropTypes.object,
				location: _react2['default'].PropTypes.object
			},
			enumerable: true
		}, {
			key: 'defaultProps',
			value: {
				newTitle: 'Nový',
				listTitle: 'Seznam',
				disableAdd: false
			},
			enumerable: true
		}]);
	
		var _TabbablePage = TabbablePage;
		TabbablePage = _wrapComponent('_$TabbablePage')(TabbablePage) || TabbablePage;
		TabbablePage = _reactRedux.connect(function (state, props) {
			return {
				tabs: state.tabs[props.module].tabs,
				selectedTab: state.tabs[props.module].selected
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(actions, dispatch) };
		})(TabbablePage) || TabbablePage;
		return TabbablePage;
	})(_react2['default'].Component);
	
	exports['default'] = TabbablePage;
	module.exports = exports['default'];

/***/ },

/***/ 129:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _ActionButton = __webpack_require__(105);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _components = {
		_$SaveButton: {
			displayName: 'SaveButton'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var SaveButton = (function (_ActionButton) {
		_inherits(SaveButton, _ActionButton);
	
		function SaveButton() {
			_classCallCheck(this, _SaveButton);
	
			_ActionButton.apply(this, arguments);
		}
	
		SaveButton.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(_reactisLoader.LoadingButton, {
				loading: this.props.loading,
				disabled: this.props.disabled,
				title: 'Uložit',
				onClick: function () {
					return _this.handleClick();
				}
			});
		};
	
		var _SaveButton = SaveButton;
		SaveButton = _wrapComponent('_$SaveButton')(SaveButton) || SaveButton;
		return SaveButton;
	})(_ActionButton2['default']);
	
	exports['default'] = SaveButton;
	module.exports = exports['default'];

/***/ },

/***/ 130:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	exports.__esModule = true;
	exports['default'] = reducer;
	exports.login = login;
	exports.logout = logout;
	var LOGIN = '@@auth/LOGIN';
	var LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS';
	exports.LOGIN_SUCCESS = LOGIN_SUCCESS;
	var LOGIN_FAIL = '@@auth/LOGIN_FAIL';
	var LOGOUT = '@@auth/LOGOUT';
	var LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS';
	var LOGOUT_FAIL = '@@auth/LOGOUT_FAIL';
	
	var initialState = {
	  loaded: false
	};
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case LOGIN:
	      return _extends({}, state, {
	        loggingIn: true
	      });
	    case LOGIN_SUCCESS:
	      return _extends({}, state, {
	        loggingIn: false,
	        isLoggedIn: true,
	        identity: action.result.auth.identity
	      });
	    case LOGIN_FAIL:
	      return _extends({}, state, {
	        loggingIn: false,
	        isLoggedIn: false,
	        loginError: action.error.message
	      });
	    case LOGOUT:
	      return _extends({}, state, {
	        loggingOut: true
	      });
	    case LOGOUT_SUCCESS:
	      return _extends({}, state, {
	        loggingOut: false,
	        isLoggedIn: false,
	        identity: null
	      });
	    case LOGOUT_FAIL:
	      return _extends({}, state, {
	        loggingOut: false,
	        logoutError: action.error
	      });
	    default:
	      return state;
	  }
	}
	
	function login(values) {
	  return {
	    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
	    promise: function promise(client) {
	      return client.call('login', _extends({}, values), { progress: true });
	    }
	  };
	}
	
	function logout() {
	  return {
	    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
	    promise: function promise(client) {
	      return client.call('logout', null, { progress: true });
	    }
	  };
	}

/***/ },

/***/ 168:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _socketIoClient = __webpack_require__(496);
	
	var _socketIoClient2 = _interopRequireDefault(_socketIoClient);
	
	var _transportJsonrpc = __webpack_require__(1062);
	
	var _transportJsonrpc2 = _interopRequireDefault(_transportJsonrpc);
	
	var _transportWebsockets = __webpack_require__(1063);
	
	var _transportWebsockets2 = _interopRequireDefault(_transportWebsockets);
	
	var _bluebird = __webpack_require__(539);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactProgress2 = __webpack_require__(454);
	
	var _reactProgress22 = _interopRequireDefault(_reactProgress2);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	function initSocket() {
		var ws = 'WebSocket' in window && window.WebSocket.CLOSING === 2;
		var socket = undefined;
		if (ws) {
			socket = _socketIoClient2['default']('http://reactis.vyvoj.ondrejnovak.eu:3000');
			socket.on('connect', function () {
				console.log('connect');
				socket.emit('init', { text: 'hello' });
			});
			socket.on('time', function (msg) {
				console.log(msg);
			});
			socket.on('event', function (msg) {
				console.log('Event receive');
				console.log(msg);
				_EventEmitter2['default'].emit(msg.event, msg.payload);
			});
		} else {
			socket = {
				connected: false,
				legacyBrowser: true
			};
		}
		return socket;
	}
	//global.socket = initSocket();
	
	/*
	 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
	 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
	 *
	 * Remove it at your own risk.
	 */
	
	var _ApiClient = (function () {
		function _ApiClient() {
			_classCallCheck(this, _ApiClient);
		}
	
		_ApiClient.prototype.call = function call(method, params, options) {
			if (!params) {
				params = {};
			}
			options = _extends({}, options);
			params._token = '___';
			var transportLayer = undefined;
			/*if (global.socket.connected) {
	  	transportLayer = new JsonRpcWS(global.socket);
	  }
	  else {
	  	transportLayer = new JsonRpcAjax('/api');
	  }*/
			transportLayer = new _transportJsonrpc2['default']('/api');
	
			var promise = new _bluebird2['default'](function (resolve, reject) {
				if (options.progress) {
					_reactProgress22['default'].show();
				}
				transportLayer.call(method, params, function (err, data) {
					if (options.progress) {
						_reactProgress22['default'].hide();
					}
					if (err) {
						if (err.code == 500) {
							alert("Nastala vnitřní chyba a server nebyl schopen dokončit Váš požadavek.\nOpakujte akci později.");
						}
						if (err.code == 401) {
							window.location = '/';
						}
						if (err.code == 403) {
							alert("Nemáte oprávnění akci provést.");
						}
						reject(err);
					}
					resolve(data);
				});
			});
			return promise;
		};
	
		return _ApiClient;
	})();
	
	var ApiClient = _ApiClient;
	exports['default'] = ApiClient;
	module.exports = exports['default'];

/***/ },

/***/ 243:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _helpersApiClient = __webpack_require__(168);
	
	var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _Lookup = __webpack_require__(502);
	
	var _Lookup2 = _interopRequireDefault(_Lookup);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = {
		_$UserLookup: {
			displayName: 'UserLookup'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var UserLookup = (function (_Component) {
		_inherits(UserLookup, _Component);
	
		function UserLookup() {
			_classCallCheck(this, _UserLookup);
	
			_Component.apply(this, arguments);
		}
	
		UserLookup.prototype.api = function api(q, page) {
			var client = new _helpersApiClient2['default']();
			return client.call('user.lookup', { q: q, page: page });
		};
	
		UserLookup.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(_Lookup2['default'], _extends({ query: function (q, page) {
					return _this.api(q, page);
				} }, this.props));
		};
	
		var _UserLookup = UserLookup;
		UserLookup = _wrapComponent('_$UserLookup')(UserLookup) || UserLookup;
		return UserLookup;
	})(_Component2['default']);
	
	exports['default'] = UserLookup;
	module.exports = exports['default'];

/***/ },

/***/ 247:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isString = isString;
	exports.arrify = arrify;
	exports.resolve = resolve;
	exports.getWindowSize = getWindowSize;
	var _ = __webpack_require__(208);
	
	function isString(value) {
		return typeof value === 'string';
	}
	
	function arrify(obj) {
		if (!obj) {
			return [];
		}
	
		if (_.isArray(obj)) {
			return obj;
		}
	
		return [obj];
	}
	
	function resolve(object, path) {
		return path.split('.').reduce(function (prev, curr) {
			return prev[curr];
		}, object || this);
	}
	
	function getWindowSize() {
		var w = window,
		    d = document,
		    e = d.documentElement,
		    g = d.getElementsByTagName('body')[0],
		    x = w.innerWidth || e.clientWidth || g.clientWidth,
		    y = w.innerHeight || e.clientHeight || g.clientHeight;
	
		return { width: x, height: y };
	}

/***/ },

/***/ 502:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _immutable = __webpack_require__(19);
	
	var immutable = _interopRequireWildcard(_immutable);
	
	var _components = {
		_$Unknown: {}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Lookup = _wrapComponent('_$Unknown')(_react2['default'].createClass({
		propTypes: {
			// Data for Select2,
			dataSet: _react2['default'].PropTypes.array.isRequired,
	
			// If true apply the prop `errorClass`
			hasError: _react2['default'].PropTypes.bool,
	
			// Class to apply if hasError is true.
			errorClass: _react2['default'].PropTypes.string,
	
			// Function to call with currently selected elements
			onSelection: _react2['default'].PropTypes.func,
	
			// Allow multiple selections
			multiple: _react2['default'].PropTypes.bool,
	
			// Placeholder to display in select
			placeholder: _react2['default'].PropTypes.string,
	
			// inline style for select
			styleWidth: _react2['default'].PropTypes.string,
	
			// enable or disable the input
			enabled: _react2['default'].PropTypes.bool
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				hasError: false,
				errorClass: "has-error", // default to Bootstrap 3's error class
				multiple: false,
				placeholder: ' ',
				value: [],
				styleWidth: "100%",
				enabled: true,
				minLength: 0,
				allowClear: true,
				dataSet: []
			};
		},
	
		///////////////////////////////
		// Lifecycle
		///////////////////////////////
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			if (this._isDataUpdated(prevProps.dataSet)) {
				// "brute-force" new data into our Select2 widget since Select2 doesn't
				// have a method for changng data on already-existing widgets
				this.createSelect2();
			} else {
				// Change placeholder
				if (prevProps.placeholder !== this.props.placeholder) {
					this.setPlaceholderTo(this.getInputElem(), this.props.placeholder);
				}
	
				// Handle val prop
				/*var updateVal = false;
	   // ...if length of old val prop and new val prop arrays are the same,
	   //    we'll need to check the elements
	   if (prevProps.value.length == this.props.value.length) {
	   	$.each(prevProps.value, function (index, value) {
	   		if (this.props.value[index] != value) {
	   			updateVal = true;
	   		}
	   	}.bind(this));
	   		} else {
	   	updateVal = true;
	   }
	   // ...update our val if we need to
	   if (updateVal) {
	   		}*/
				var value = this.props.value instanceof immutable.Map ? this.props.value.toJS() : this.props.value;
				this.getInputElem().select2("val", value);
				// Enable/disable
				if (prevProps.enabled != this.props.enabled) {
					this.getInputElem().select2("enable", this.props.enabled);
				}
			}
		},
	
		componentDidMount: function componentDidMount() {
			// Set up Select2
			var $node = this.createSelect2();
		},
	
		componentWillUnmount: function componentWillUnmount() {
			$(_reactDom2['default'].findDOMNode(this.refs.input)).select2("destroy");
		},
	
		///////////////////////////////
		// Manipulate Select2
		///////////////////////////////
		setPlaceholderTo: function setPlaceholderTo($elem, placeholder) {
			if (!placeholder) {
				placeholder = "";
			}
			var currData = $elem.select2("data");
	
			// Set placeholder to new placeholder
			$elem.attr("placeholder", placeholder);
	
			// Now workaround the fact that Select2 doesn't pick up on this
			// ..First assign null
			$elem.select2("data", null);
	
			// ..Then assign dummy value in case that currData is null since
			//   that won't do anything.
	
			$elem.select2("data", {});
	
			// ..Then put original data back
			$elem.select2("data", currData);
		},
	
		getValue: function getValue() {
			var $node = this.getInputElem();
			return $node.data('value') !== null ? $node.data('value') : undefined;
		},
	
		createSelect2: function createSelect2() {
			var me = this;
			// Get inital value
			var val = null;
			var value = this.props.value instanceof immutable.Map ? this.props.value.toJS() : this.props.value;
			if (Object.prototype.toString.call(value) === '[object Array]') {
				if (value.length > 0) {
					val = this.props.multiple ? value : value[0];
				}
			} else {
				val = value;
			}
	
			var options = {
				data: this.props.dataSet,
				minimumInputLength: this.props.minLength,
				multiple: this.props.multiple,
				val: val,
				allowClear: this.props.allowClear
			};
	
			options.initSelection = function (element, callback) {
				var data = element.data('value');
				return callback(data);
			};
	
			options.query = function (query) {
				me.props.query(query.term, query.page).then(function (data) {
					query.callback(data);
				});
			};
	
			var $node = this.getInputElem();
			$node.val(val).select2(options).on("change", this.handleChange).on("select2-open", this.handleErrorState).select2("enable", this.props.enabled).select2("val", val);
			this.setPlaceholderTo($node, this.props.placeholder);
		},
	
		///////////////////////////////
		// Helpers
		///////////////////////////////
		handleErrorState: function handleErrorState() {
			var $dropNode = $('#select2-drop');
			var classNames = $dropNode[0].className.split(/\s+/);
	
			if (this.props.hasError) {
				var hasErrorClass = $.inArray(this.props.errorClass, classNames);
	
				if (hasErrorClass == -1) {
					$dropNode.addClass(this.props.errorClass);
				}
			} else {
				$dropNode.removeClass(this.props.errorClass);
			}
		},
	
		handleChange: function handleChange(e) {
			var value = immutable.fromJS(this.getValue());
			if (this.props.onChange) {
				this.props.onChange(value);
			}
			if (this.props.onBlur) {
				this.props.onBlur(value);
			}
		},
	
		getInputElem: function getInputElem() {
			return $(_reactDom2['default'].findDOMNode(this.refs.input));
		},
	
		_isDataUpdated: function _isDataUpdated(oldData) {
			// TODO: More robust dataSet checker.  Need to recurse and
			// check all elements of data set.
			if (oldData.length != this.props.dataSet.length) {
				return true;
			}
	
			return false;
		},
	
		getError: function getError() {
			return this.props.error && this.props.error[0];
		},
	
		render: function render() {
			var style = { width: this.props.styleWidth };
			return _react2['default'].createElement(
				'div',
				{ className: this.getError() ? this.props.errorClass : "" },
				_react2['default'].createElement('input', { type: 'hidden', style: style, ref: 'input' }),
				this.getError() && _react2['default'].createElement(
					'div',
					null,
					this.getError()
				)
			);
		}
	}));
	
	module.exports = Lookup;

/***/ },

/***/ 503:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _components = {
		_$RowItems: {
			displayName: 'RowItems'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var RowItems = (function (_Component) {
		_inherits(RowItems, _Component);
	
		function RowItems() {
			_classCallCheck(this, _RowItems);
	
			_Component.apply(this, arguments);
		}
	
		RowItems.prototype.render = function render() {
			var items = this.props.data.get('items').toJS().map(function (item) {
				return _react2['default'].createElement(
					'tr',
					{ key: item.id },
					_react2['default'].createElement(
						'td',
						null,
						item.title
					),
					_react2['default'].createElement(
						'td',
						{ style: { textAlign: 'right', width: 60 } },
						item.amount
					),
					_react2['default'].createElement(
						'td',
						{ style: { textAlign: 'right', width: 60 } },
						item.price
					)
				);
			});
			return _react2['default'].createElement(
				'table',
				{ className: 'detail', style: { width: 600 } },
				_react2['default'].createElement(
					'thead',
					null,
					_react2['default'].createElement(
						'tr',
						null,
						_react2['default'].createElement(
							'th',
							null,
							'Popis'
						),
						_react2['default'].createElement(
							'th',
							null,
							'Počet'
						),
						_react2['default'].createElement(
							'th',
							null,
							'Cena'
						)
					)
				),
				_react2['default'].createElement(
					'tbody',
					null,
					items
				)
			);
		};
	
		var _RowItems = RowItems;
		RowItems = _wrapComponent('_$RowItems')(RowItems) || RowItems;
		return RowItems;
	})(_componentsComponent2['default']);
	
	exports['default'] = RowItems;
	module.exports = exports['default'];

/***/ },

/***/ 510:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	exports['default'] = reducer;
	exports.save = save;
	
	var _immutable = __webpack_require__(19);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var SAVE = '@@Profile/SAVE';
	var SAVE_SUCCESS = '@@Profile/SAVE_SUCCESS';
	var SAVE_FAIL = '@@Profile/SAVE_FAIL';
	
	var initialState = _immutable2['default'].Map();
	
	function reducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
	
			case SAVE:
				return state.set('saving', true);
	
			case SAVE_SUCCESS:
			case SAVE_FAIL:
				return state.set('saving', false);
	
			default:
				return state;
		}
	}
	
	function save(data) {
		return {
			types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
			promise: function promise(client) {
				return client.call('user.saveProfile', { data: data }, { progress: true });
			}
		};
	}

/***/ },

/***/ 511:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	exports.__esModule = true;
	exports['default'] = reducer;
	exports.openTabForm = openTabForm;
	exports.selectTab = selectTab;
	exports.closeTab = closeTab;
	exports.closeOthersTab = closeOthersTab;
	exports.closeAll = closeAll;
	exports.updateTab = updateTab;
	var OPEN = '@@Tab/Open';
	var CLOSE = '@@Tab/Close';
	var CLOSE_OTHERS = '@@Tab/CloseOthers';
	var CLOSE_ALL = '@@Tab/CloseAll';
	var SELECT = '@@Tab/Select';
	var UPDATE = '@@Tab/Update';
	
	var initialState = {
		user: {
			tabs: [],
			selected: 0,
			stack: []
		},
		ticket: {
			tabs: [],
			selected: 0,
			stack: []
		},
		invoice: {
			tabs: [],
			selected: 0,
			stack: []
		},
		client: {
			tabs: [],
			selected: 0,
			stack: []
		},
		project: {
			tabs: [],
			selected: 0,
			stack: []
		},
		emailtemplate: {
			tabs: [],
			selected: 0,
			stack: []
		}
	};
	
	function reducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
			case OPEN:
				var tab = {
					title: action.title,
					id: Math.random(),
					data: action.data.id,
					unsave: !!action.data.unsave,
					values: action.data.values,
					args: action.data,
					closable: true
				};
				state[action.module].tabs.push(tab);
				state[action.module].selected = tab.id;
				state[action.module].stack.push(tab.id);
				return _extends({}, state);
	
			case SELECT:
				state[action.module].selected = action.id;
				state[action.module].stack.push(action.id);
	
				return _extends({}, state);
	
			case UPDATE:
				var tab = state[action.module].tabs.filter(function (item) {
					return action.id == item.id;
				})[0];
				if (tab) {
					var index = state[action.module].tabs.indexOf(tab);
					state[action.module].tabs[index] = _extends({}, tab, action.tab);
					state[action.module].tabs = [].concat(state[action.module].tabs);
				}
				return _extends({}, state);
	
			case CLOSE:
				state[action.module].tabs = state[action.module].tabs.filter(function (item) {
					return action.id != item.id;
				});
				if (state[action.module].selected == action.id) {
					(function () {
						state[action.module].stack.pop();
						var lastid = state[action.module].stack.pop();
						var exists = state[action.module].tabs.filter(function (item) {
							return lastid == item.id;
						}).length > 0;
						while (!exists && state[action.module].stack.length > 0) {
							lastid = state[action.module].stack.pop();
							exists = state[action.module].tabs.filter(function (item) {
								return lastid == item.id;
							}).length > 0;
						}
						state[action.module].selected = exists ? lastid : 0;
					})();
				}
				return _extends({}, state);
	
			case CLOSE_OTHERS:
				state[action.module].selected = action.id;
				state[action.module].tabs = state[action.module].tabs.filter(function (item) {
					return action.id == item.id;
				});
				return _extends({}, state);
	
			case CLOSE_ALL:
				state[action.module].selected = 0;
				state[action.module].stack = [];
				state[action.module].tabs = [];
				return _extends({}, state);
	
			default:
				return state;
		}
	}
	
	function openTabForm(module, title, data) {
		return {
			type: OPEN,
			module: module,
			title: title,
			data: data,
			url: '/' + module + '/' + data.id
		};
	}
	
	function selectTab(module, id) {
		return {
			type: SELECT,
			url: function url(state) {
				var tab = state.tabs[module].tabs.filter(function (item) {
					return item.id == id;
				})[0];
				return '/' + module + (tab ? '/' + tab.data : '');
			},
			module: module,
			id: id
		};
	}
	
	function closeTab(module, id) {
		return {
			type: CLOSE,
			module: module,
			id: id,
			url: function url(state) {
				var selected = state.tabs[module].selected;
				var tab = state.tabs[module].tabs.filter(function (item) {
					return item.id == selected;
				})[0];
				return '/' + module + (tab ? '/' + tab.data : '');
			}
		};
	}
	
	function closeOthersTab(module, id) {
		return {
			type: CLOSE_OTHERS,
			module: module,
			id: id
		};
	}
	
	function closeAll(module, id) {
		return {
			type: CLOSE_ALL,
			module: module,
			id: id
		};
	}
	
	function updateTab(module, id, tab) {
		return {
			type: UPDATE,
			module: module,
			tab: tab,
			id: id
		};
	}

/***/ },

/***/ 798:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 328,
		"./af.js": 328,
		"./ar": 332,
		"./ar-ma": 329,
		"./ar-ma.js": 329,
		"./ar-sa": 330,
		"./ar-sa.js": 330,
		"./ar-tn": 331,
		"./ar-tn.js": 331,
		"./ar.js": 332,
		"./az": 333,
		"./az.js": 333,
		"./be": 334,
		"./be.js": 334,
		"./bg": 335,
		"./bg.js": 335,
		"./bn": 336,
		"./bn.js": 336,
		"./bo": 337,
		"./bo.js": 337,
		"./br": 338,
		"./br.js": 338,
		"./bs": 339,
		"./bs.js": 339,
		"./ca": 340,
		"./ca.js": 340,
		"./cs": 341,
		"./cs.js": 341,
		"./cv": 342,
		"./cv.js": 342,
		"./cy": 343,
		"./cy.js": 343,
		"./da": 344,
		"./da.js": 344,
		"./de": 346,
		"./de-at": 345,
		"./de-at.js": 345,
		"./de.js": 346,
		"./dv": 347,
		"./dv.js": 347,
		"./el": 348,
		"./el.js": 348,
		"./en-au": 349,
		"./en-au.js": 349,
		"./en-ca": 350,
		"./en-ca.js": 350,
		"./en-gb": 351,
		"./en-gb.js": 351,
		"./en-ie": 352,
		"./en-ie.js": 352,
		"./en-nz": 353,
		"./en-nz.js": 353,
		"./eo": 354,
		"./eo.js": 354,
		"./es": 355,
		"./es.js": 355,
		"./et": 356,
		"./et.js": 356,
		"./eu": 357,
		"./eu.js": 357,
		"./fa": 358,
		"./fa.js": 358,
		"./fi": 359,
		"./fi.js": 359,
		"./fo": 360,
		"./fo.js": 360,
		"./fr": 363,
		"./fr-ca": 361,
		"./fr-ca.js": 361,
		"./fr-ch": 362,
		"./fr-ch.js": 362,
		"./fr.js": 363,
		"./fy": 364,
		"./fy.js": 364,
		"./gd": 365,
		"./gd.js": 365,
		"./gl": 366,
		"./gl.js": 366,
		"./he": 367,
		"./he.js": 367,
		"./hi": 368,
		"./hi.js": 368,
		"./hr": 369,
		"./hr.js": 369,
		"./hu": 370,
		"./hu.js": 370,
		"./hy-am": 371,
		"./hy-am.js": 371,
		"./id": 372,
		"./id.js": 372,
		"./is": 373,
		"./is.js": 373,
		"./it": 374,
		"./it.js": 374,
		"./ja": 375,
		"./ja.js": 375,
		"./jv": 376,
		"./jv.js": 376,
		"./ka": 377,
		"./ka.js": 377,
		"./kk": 378,
		"./kk.js": 378,
		"./km": 379,
		"./km.js": 379,
		"./ko": 380,
		"./ko.js": 380,
		"./lb": 381,
		"./lb.js": 381,
		"./lo": 382,
		"./lo.js": 382,
		"./lt": 383,
		"./lt.js": 383,
		"./lv": 384,
		"./lv.js": 384,
		"./me": 385,
		"./me.js": 385,
		"./mk": 386,
		"./mk.js": 386,
		"./ml": 387,
		"./ml.js": 387,
		"./mr": 388,
		"./mr.js": 388,
		"./ms": 390,
		"./ms-my": 389,
		"./ms-my.js": 389,
		"./ms.js": 390,
		"./my": 391,
		"./my.js": 391,
		"./nb": 392,
		"./nb.js": 392,
		"./ne": 393,
		"./ne.js": 393,
		"./nl": 394,
		"./nl.js": 394,
		"./nn": 395,
		"./nn.js": 395,
		"./pl": 396,
		"./pl.js": 396,
		"./pt": 398,
		"./pt-br": 397,
		"./pt-br.js": 397,
		"./pt.js": 398,
		"./ro": 399,
		"./ro.js": 399,
		"./ru": 400,
		"./ru.js": 400,
		"./se": 401,
		"./se.js": 401,
		"./si": 402,
		"./si.js": 402,
		"./sk": 403,
		"./sk.js": 403,
		"./sl": 404,
		"./sl.js": 404,
		"./sq": 405,
		"./sq.js": 405,
		"./sr": 407,
		"./sr-cyrl": 406,
		"./sr-cyrl.js": 406,
		"./sr.js": 407,
		"./sv": 408,
		"./sv.js": 408,
		"./sw": 409,
		"./sw.js": 409,
		"./ta": 410,
		"./ta.js": 410,
		"./te": 411,
		"./te.js": 411,
		"./th": 412,
		"./th.js": 412,
		"./tl-ph": 413,
		"./tl-ph.js": 413,
		"./tlh": 414,
		"./tlh.js": 414,
		"./tr": 415,
		"./tr.js": 415,
		"./tzl": 416,
		"./tzl.js": 416,
		"./tzm": 418,
		"./tzm-latn": 417,
		"./tzm-latn.js": 417,
		"./tzm.js": 418,
		"./uk": 419,
		"./uk.js": 419,
		"./uz": 420,
		"./uz.js": 420,
		"./vi": 421,
		"./vi.js": 421,
		"./zh-cn": 422,
		"./zh-cn.js": 422,
		"./zh-tw": 423,
		"./zh-tw.js": 423
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 798;


/***/ },

/***/ 974:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	//import 'babel/polyfill';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _historyLibCreateBrowserHistory = __webpack_require__(747);
	
	var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);
	
	var _scrollBehaviorLibUseStandardScroll = __webpack_require__(966);
	
	var _scrollBehaviorLibUseStandardScroll2 = _interopRequireDefault(_scrollBehaviorLibUseStandardScroll);
	
	var _reduxCreate = __webpack_require__(1052);
	
	var _reduxCreate2 = _interopRequireDefault(_reduxCreate);
	
	var _helpersApiClient = __webpack_require__(168);
	
	var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);
	
	var _socketIoClient = __webpack_require__(496);
	
	var _socketIoClient2 = _interopRequireDefault(_socketIoClient);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(460);
	
	var _reactisAcl = __webpack_require__(1006);
	
	var _routes = __webpack_require__(1061);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _helpersMakeRouteHooksSafe = __webpack_require__(1001);
	
	var _helpersMakeRouteHooksSafe2 = _interopRequireDefault(_helpersMakeRouteHooksSafe);
	
	__webpack_require__(535);
	
	var acl = new _reactisAcl.Acl(window._acl);
	var user = new _reactisAcl.User(acl, window._initState.auth ? window._initState.auth.roles : []);
	
	var client = new _helpersApiClient2['default']();
	var keepAlive = function keepAlive() {
		client.call('system.keepalive');
		setTimeout(keepAlive, 60000);
	};
	setTimeout(keepAlive, 60000);
	
	// Three different types of scroll behavior available.
	// Documented here: https://github.com/rackt/scroll-behavior
	var history = _scrollBehaviorLibUseStandardScroll2['default'](_historyLibCreateBrowserHistory2['default'])();
	
	var dest = document.getElementById('app');
	var store = _reduxCreate2['default'](client, history, window._initState);
	
	//syncReduxAndRouter(history, store);
	
	var component = _react2['default'].createElement(
		_reactisAcl.UserProvider,
		{ user: user },
		_react2['default'].createElement(
			_reactRouter.Router,
			{ history: history },
			_routes2['default'](store)
		)
	);
	
	_reactDom2['default'].render(_react2['default'].createElement(
		_reactRedux.Provider,
		{ store: store, key: 'provider' },
		component
	), dest);
	
	if (false) {
		window.React = _react2['default']; // enable debugger
	}

/***/ },

/***/ 975:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _Component = __webpack_require__(21);
	
	var _Component2 = _interopRequireDefault(_Component);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscoreString = __webpack_require__(1082);
	
	var _underscoreString2 = _interopRequireDefault(_underscoreString);
	
	var _components = {
		_$ClosableTab: {
			displayName: 'ClosableTab'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var ClosableTab = (function (_Component) {
		_inherits(ClosableTab, _Component);
	
		function ClosableTab() {
			_classCallCheck(this, _ClosableTab);
	
			_Component.apply(this, arguments);
		}
	
		ClosableTab.prototype.handleClose = function handleClose(e) {
			e.preventDefault();
			e.stopPropagation();
			if (this.props.onClose) {
				this.props.onClose(this.props.id);
			}
		};
	
		ClosableTab.prototype.render = function render() {
			var _this = this;
	
			var truncated = _underscoreString2['default'].truncate(this.props.title, 26);
			return _react2['default'].createElement(
				'span',
				{ className: 'closabletab' },
				_react2['default'].createElement('i', { onClick: function (e) {
						return _this.handleClose(e);
					}, className: 'tabclose icon-cross' }),
				_react2['default'].createElement(
					'span',
					null,
					truncated,
					this.props.unsave && _react2['default'].createElement(
						'span',
						null,
						' *'
					)
				)
			);
		};
	
		var _ClosableTab = ClosableTab;
		ClosableTab = _wrapComponent('_$ClosableTab')(ClosableTab) || ClosableTab;
		return ClosableTab;
	})(_Component2['default']);
	
	exports['default'] = ClosableTab;
	module.exports = exports['default'];

/***/ },

/***/ 976:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reduxModulesAuth = __webpack_require__(130);
	
	var _utilsUtils = __webpack_require__(247);
	
	var _components = {
		_$TopNavBar: {
			displayName: 'TopNavBar'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var TopNavBar = (function (_React$Component) {
		_inherits(TopNavBar, _React$Component);
	
		function TopNavBar() {
			_classCallCheck(this, _TopNavBar);
	
			_React$Component.apply(this, arguments);
		}
	
		TopNavBar.prototype.handleLogout = function handleLogout(e) {
			e.preventDefault();
			this.props.logout();
		};
	
		TopNavBar.prototype.redirect = function redirect(e, url, params) {
			e.preventDefault();
			this.context.history.pushState(null, url, params);
		};
	
		TopNavBar.prototype.render = function render() {
			var _this = this;
	
			var items = [{
				id: 'ticket',
				title: 'Požadavky',
				url: '/ticket',
				icon: 'fa fa-check',
				onClick: function onClick(e) {
					_this.redirect(e, '/ticket');
				}
			}, {
				id: 'invoice',
				title: 'Faktury',
				url: '/invoice',
				icon: 'fa fa-eur',
				onClick: function onClick(e) {
					_this.redirect(e, '/invoice');
				}
			}, {
				id: 'project',
				title: 'Projekty',
				url: '/project',
				icon: 'fa fa-cubes',
				onClick: function onClick(e) {
					_this.redirect(e, '/project');
				}
			}, {
				id: 'client',
				title: 'Klienti',
				url: '/client',
				icon: 'icon-users',
				onClick: function onClick(e) {
					_this.redirect(e, '/client');
				}
			}, {
				id: 'setting',
				title: 'Nastavení',
				icon: 'fa fa-cog',
				items: [{
					id: 'user',
					title: 'Uživatelé',
					url: '/user',
					icon: 'icon-user',
					onClick: function onClick(e) {
						_this.redirect(e, '/user');
					}
				}, {
					id: 'emailtemplate',
					title: 'E-mailové šablony',
					url: '/emailtemplate',
					icon: 'fa fa-envelope-o',
					onClick: function onClick(e) {
						_this.redirect(e, '/emailtemplate');
					}
				}]
			}];
			var activeRoute = this.props.routes[this.props.routes.length - 1].menu || this.props.routes[this.props.routes.length - 1].name;
	
			var buttons = items.map(function (button) {
	
				if (button.items) {
					var subitems = button.items.map(function (button) {
						return _react2['default'].createElement(
							'li',
							{ key: button.id, className: _classnames2['default']({ active: activeRoute == button.id }) },
							_react2['default'].createElement(
								'a',
								{ href: button.url, onClick: button.onClick },
								_react2['default'].createElement('span', { style: { fontSize: 12 }, className: button.icon + " position-left" }),
								' ',
								button.title
							)
						);
					});
					return _react2['default'].createElement(
						'li',
						{ key: button.id, className: _classnames2['default']({ dropdown: true, active: activeRoute == button.id }) },
						_react2['default'].createElement(
							'a',
							{ href: '#', onClick: button.onClick, className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
							_react2['default'].createElement('span', { className: button.icon + " position-left" }),
							' ',
							button.title,
							' ',
							_react2['default'].createElement('span', { className: 'caret' })
						),
						_react2['default'].createElement(
							'ul',
							{ className: 'dropdown-menu', role: 'menu' },
							subitems
						)
					);
				}
				return _react2['default'].createElement(
					'li',
					{ key: button.id, className: _classnames2['default']({ active: activeRoute == button.id }) },
					_react2['default'].createElement(
						'a',
						{ href: button.url, onClick: button.onClick },
						_react2['default'].createElement('span', { className: button.icon + " position-left" }),
						' ',
						button.title
					)
				);
			});
	
			var isPhone = _utilsUtils.getWindowSize().width < 768;
	
			return _react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement(
					'div',
					{ className: 'navbar ' + (isPhone ? 'navbar-inverse' : 'navbar-default') },
					_react2['default'].createElement(
						'div',
						{ className: 'navbar-header' },
						_react2['default'].createElement(
							'a',
							{ className: 'navbar-brand visible-xs-block', href: '/', style: { fontWeight: 'bold', color: '#FFF' } },
							'Alertoid'
						),
						_react2['default'].createElement(
							'ul',
							{ className: 'nav navbar-nav no-border visible-xs-block' },
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'a',
									{ className: 'text-right  collapsed', 'data-toggle': 'collapse', 'data-target': '#navbar-second-toggle' },
									_react2['default'].createElement('i', { className: 'icon-menu7' })
								)
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'navbar-collapse collapse', id: 'navbar-second-toggle' },
						_react2['default'].createElement(
							'ul',
							{ className: 'nav navbar-nav' },
							buttons
						),
						_react2['default'].createElement(
							'ul',
							{ className: 'nav navbar-nav navbar-right' },
							_react2['default'].createElement(
								'li',
								{ className: 'dropdown' },
								_react2['default'].createElement(
									'a',
									{ href: '#', className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
									_react2['default'].createElement('span', { className: 'glyphicon glyphicon-user' }),
									' ',
									this.props.user && this.props.user.name,
									_react2['default'].createElement('span', { className: 'caret' })
								),
								_react2['default'].createElement(
									'ul',
									{ className: 'dropdown-menu', role: 'menu' },
									_react2['default'].createElement(
										'li',
										null,
										_react2['default'].createElement(
											'a',
											{ href: '#', onClick: function (e) {
													return _this.redirect(e, '/profile');
												} },
											_react2['default'].createElement('i', { className: 'icon-user-plus' }),
											' Můj profil'
										)
									),
									_react2['default'].createElement('li', { className: 'divider' }),
									_react2['default'].createElement(
										'li',
										null,
										_react2['default'].createElement(
											'a',
											{ onClick: function (e) {
													return _this.handleLogout(e);
												}, href: '#' },
											_react2['default'].createElement('i', { className: 'icon-switch2' }),
											' Odhlásit'
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		_createClass(TopNavBar, null, [{
			key: 'contextTypes',
			value: {
				history: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _TopNavBar = TopNavBar;
		TopNavBar = _wrapComponent('_$TopNavBar')(TopNavBar) || TopNavBar;
		TopNavBar = _reactRedux.connect(function (state) {
			return { user: state.auth.identity };
		}, { logout: _reduxModulesAuth.logout })(TopNavBar) || TopNavBar;
		return TopNavBar;
	})(_react2['default'].Component);
	
	exports['default'] = TopNavBar;
	module.exports = exports['default'];

/***/ },

/***/ 977:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactDocumentMeta = __webpack_require__(216);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reduxModulesAuth = __webpack_require__(130);
	
	var _reactProgress2 = __webpack_require__(454);
	
	var _reactProgress22 = _interopRequireDefault(_reactProgress2);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$App: {
			displayName: 'App'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var App = (function (_Component) {
		_inherits(App, _Component);
	
		function App() {
			_classCallCheck(this, _App);
	
			_Component.apply(this, arguments);
		}
	
		App.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			if (!this.props.user && nextProps.user) {
				if (nextProps.location.query.backlink) {
					this.context.history.pushState(null, nextProps.location.query.backlink);
				} else {
					this.context.history.pushState(null, '/');
				}
			} else if (this.props.user && !nextProps.user) {
				window.location = '/login';
			}
		};
	
		App.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'CRM' },
				_react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_reactProgress22['default'].Component, null),
					this.props.children
				)
			);
		};
	
		_createClass(App, null, [{
			key: 'propTypes',
			value: {
				children: _react.PropTypes.object.isRequired,
				user: _react.PropTypes.object
			},
			enumerable: true
		}, {
			key: 'contextTypes',
			value: {
				store: _react.PropTypes.object.isRequired,
				history: _react2['default'].PropTypes.object,
				location: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		var _App = App;
		App = _wrapComponent('_$App')(App) || App;
		App = _reactRedux.connect(function (state) {
			return { user: state.auth.identity };
		})(App) || App;
		return App;
	})(_react.Component);
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 978:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentMeta = __webpack_require__(216);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _componentsTopMenu = __webpack_require__(976);
	
	var _componentsTopMenu2 = _interopRequireDefault(_componentsTopMenu);
	
	var _reactisModal = __webpack_require__(29);
	
	var _components = {
		_$App: {
			displayName: 'App'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var App = (function (_Component) {
		_inherits(App, _Component);
	
		function App() {
			_classCallCheck(this, _App);
	
			_Component.apply(this, arguments);
		}
	
		App.prototype.render = function render() {
			return _react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement(_reactisModal.ModalWindowContainer, null),
				_react2['default'].createElement(_componentsTopMenu2['default'], this.props),
				_react2['default'].createElement(
					'div',
					{ className: 'page-container' },
					_react2['default'].createElement(
						'div',
						{ className: 'page-content' },
						_react2['default'].createElement(
							'div',
							{ className: 'content-wrapper' },
							this.props.children
						)
					)
				)
			);
		};
	
		_createClass(App, null, [{
			key: 'propTypes',
			value: {
				children: _react.PropTypes.object.isRequired
			},
			enumerable: true
		}]);
	
		var _App = App;
		App = _wrapComponent('_$App')(App) || App;
		return App;
	})(_react.Component);
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 979:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsActionButton = __webpack_require__(105);
	
	var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);
	
	var _componentsSaveButton = __webpack_require__(129);
	
	var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _components = {
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'client.fetch',
				save: 'client.save',
				remove: 'client.delete'
			};
	
			this.changeEvent = 'client.change';
	
			this.messages = {
				remove: 'Opravdu chcete zákazníka odstranit?',
				notfound: 'Zákazník nenalezen!'
			};
	
			this.schema = {
				title: {
					'class': _reactisInputs.TextInput,
					label: 'Obchodní název',
					rules: {
						presence: { message: 'Zadejte obchodní název!' }
					}
				},
	
				ic: {
					'class': _reactisInputs.TextInput,
					label: 'IČ',
					style: { width: 120 }
				},
	
				dic: {
					'class': _reactisInputs.TextInput,
					label: 'DIČ',
					style: { width: 120 }
				},
	
				sector: {
					'class': _reactisInputs.TextInput,
					label: 'Obor'
				},
	
				email: {
					'class': _reactisInputs.TextInput,
					label: 'E-mail'
				},
	
				phone: {
					'class': _reactisInputs.TextInput,
					label: 'Telefon'
				},
	
				street: {
					'class': _reactisInputs.TextInput,
					label: 'Ulice'
				},
	
				city: {
					'class': _reactisInputs.TextInput,
					label: 'Město',
					style: { width: 250 }
				},
	
				zip: {
					'class': _reactisInputs.TextInput,
					label: 'PSČ',
					style: { width: 80 }
				},
	
				invoice_street: {
					'class': _reactisInputs.TextInput,
					label: 'Ulice'
				},
	
				invoice_city: {
					'class': _reactisInputs.TextInput,
					label: 'Město',
					style: { width: 250 }
				},
	
				invoice_zip: {
					'class': _reactisInputs.TextInput,
					label: 'PSČ',
					style: { width: 80 }
				},
	
				image: {
					'class': _reactisInputs.ImageUpload,
					label: 'Logo'
				},
	
				notice: {
					'class': _reactisInputs.TextArea,
					label: 'Interní poznámka',
					style: { height: '60px' }
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this = this;
	
			this.form.on('change', function (key, value) {
				if (key == 'title') {
					_this.title = value;
				}
				_this.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: data.title });
		};
	
		Form.prototype.render = function render() {
			var _this2 = this;
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				_react2['default'].createElement(_reactisLoader.LoadingButton, {
					loading: !!(this.props.form && this.props.form.get('saving')),
					disabled: !this.form.isChanged(),
					title: 'Uložit',
					onClick: function () {
						return _this2.save();
					}
				}),
				this.props.id > 0 && _react2['default'].createElement(
					_reactBootstrap.Button,
					{ bsStyle: 'danger', className: 'input-group', onClick: function () {
							return _this2.remove();
						} },
					_react2['default'].createElement('i', { className: 'fa fa-trash-o' }),
					' Odstranit'
				)
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Subjekt', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-6' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'title', labelWidth: '135' }),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'form' }),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'phone' }),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'email' }),
									_react2['default'].createElement(
										'tr',
										null,
										_react2['default'].createElement(
											'th',
											null,
											'IČ:'
										),
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(_reactisForms.FormField, { name: 'ic' }),
											'   DIČ: ',
											_react2['default'].createElement(_reactisForms.FormField, { name: 'dic' }),
											_react2['default'].createElement(
												_reactBootstrap.Button,
												{ className: 'hide', onClick: function (e) {
														return null;
													}, bsStyle: 'default', href: '#', style: { marginTop: -1, marginLeft: 20 } },
												_react2['default'].createElement('i', { className: 'clip-download' }),
												' Načíst data z ARESu'
											)
										)
									),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'image' }),
									_react2['default'].createElement(
										'tr',
										{ className: 'divider' },
										_react2['default'].createElement(
											'td',
											{ colSpan: '2' },
											_react2['default'].createElement(
												'h6',
												null,
												'Fakturační adresa'
											)
										)
									),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'invoice_street' }),
									_react2['default'].createElement(
										'tr',
										null,
										_react2['default'].createElement(
											'th',
											null,
											'Město:'
										),
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(_reactisForms.FormField, { name: 'invoice_city' }),
											'   PSČ: ',
											_react2['default'].createElement(_reactisForms.FormField, { name: 'invoice_zip' })
										)
									),
									_react2['default'].createElement(
										'tr',
										{ className: 'divider' },
										_react2['default'].createElement(
											'td',
											{ colSpan: '2' },
											_react2['default'].createElement(
												'h6',
												null,
												'Adresa'
											)
										)
									),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'street' }),
									_react2['default'].createElement(
										'tr',
										null,
										_react2['default'].createElement(
											'th',
											null,
											'Město:'
										),
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(_reactisForms.FormField, { name: 'city' }),
											'   PSČ: ',
											_react2['default'].createElement(_reactisForms.FormField, { name: 'zip' })
										)
									),
									_react2['default'].createElement(
										'tr',
										{ className: 'divider' },
										_react2['default'].createElement(
											'td',
											{ colSpan: '2' },
											' '
										)
									),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'notice' }),
									_react2['default'].createElement(
										'tr',
										{ className: 'buttons' },
										_react2['default'].createElement('td', { style: { width: 135 } }),
										_react2['default'].createElement(
											'td',
											null,
											_react2['default'].createElement(_reactisLoader.LoadingButton, {
												loading: !!(this.props.form && this.props.form.get('saving')),
												title: 'Uložit',
												disabled: !this.form.isChanged(),
												onClick: function () {
													return _this2.save();
												}
											})
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 980:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _redux = __webpack_require__(27);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/project/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			}, {
				name: 'email',
				title: 'E-mail',
				field: 'email',
				viewport: 'tablet'
			},
			/*{
	   name: 'phone',
	   title: 'Telefon',
	   field: 'phone',
	   viewport: 'tablet'
	   },*/
			{
				name: 'street',
				title: 'Ulice',
				field: 'street',
				viewport: 'tablet'
			}, {
				name: 'city',
				title: 'Město',
				field: 'city',
				viewport: 'tablet'
			}, {
				name: 'zip',
				title: 'PSČ',
				field: 'zip',
				width: 80,
				viewport: 'desktop'
			},
	
			/*{
	   name: 'active',
	   title: 'Aktivní',
	   field: 'active',
	   width: 60,
	   align: 'center',
	   viewport: 'tablet',
	   renderer: Renderers.coloredCheck
	   },*/
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/project/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' Upravit'
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				title: { 'class': _reactisInputs.FilterInput },
				fulltext: { 'class': _reactisInputs.SearchInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'title', 'direction': 'asc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('client.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('client.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('client', row.title, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.render = function render() {
			var _this3 = this;
	
			var buttons = _react2['default'].createElement(
				_reactBootstrap.Button,
				{ href: '/project/0', onClick: function (e) {
						return _this3.handleNewClick(e);
					} },
				_react2['default'].createElement('i', { className: 'fa fa-plus' }),
				' Nový klient'
			);
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'client',
				api: 'client.getList',
				buttons: buttons,
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				getRowClassName: null,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 981:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(980);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(979);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Page: {
			displayName: 'Page'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Page = (function (_React$Component) {
		_inherits(Page, _React$Component);
	
		function Page() {
			_classCallCheck(this, _Page);
	
			_React$Component.apply(this, arguments);
		}
	
		Page.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'Klienti' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'client',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nový',
					listTitle: 'Seznam klientů'
				}, this.props))
			);
		};
	
		var _Page = Page;
		Page = _wrapComponent('_$Page')(Page) || Page;
		return Page;
	})(_react2['default'].Component);
	
	exports['default'] = Page;
	module.exports = exports['default'];

/***/ },

/***/ 982:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _components = {
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'emailtemplate.fetch',
				save: 'emailtemplate.save'
			};
	
			this.changeEvent = 'emailtemplate.change';
	
			this.messages = {
				notfound: 'E-mailová šablona nenalezena!'
			};
	
			this.schema = {
				title: {
					'class': _reactisInputs.TextInput,
					label: 'Název',
					autoFocus: !props.id,
					rules: {
						presence: { message: 'Název je povinná položka!' }
					}
				},
				from: {
					'class': _reactisInputs.TextInput,
					label: 'Od (e-mail)'
				},
				from_name: {
					'class': _reactisInputs.TextInput,
					label: 'Od (jméno)'
				},
				to: {
					'class': _reactisInputs.TextInput,
					label: 'Komu (e-mail)'
				},
				/*cc: {
	   	class: TextInput,
	   	label: 'Kopie (e-mail)'
	   },*/
				bcc: {
					'class': _reactisInputs.TextInput,
					label: 'Skrytá kopie (e-mail)'
				},
				subject: {
					'class': _reactisInputs.TextInput,
					label: 'Předmět e-mailu'
				},
				text: {
					'class': _reactisInputs.CKEditor,
					label: 'Text'
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this = this;
	
			this.form.on('change', function (key, value) {
				if (key == 'title') {
					_this.title = value;
				}
				_this.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: data.title });
		};
	
		Form.prototype.render = function render() {
			var _this2 = this;
	
			var loading = !!(this.props.form && this.props.form.get('loading'));
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				_react2['default'].createElement(_reactisLoader.LoadingButton, {
					loading: !!(this.props.form && this.props.form.get('saving')),
					title: 'Uložit',
					onClick: function () {
						return _this2.save();
					}
				})
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'E-mailová šablona', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-10' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_Object$keys(this.schema).map(function (key) {
										return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '145' });
									}),
									_react2['default'].createElement(
										_reactisForms.FormRow,
										{ className: 'buttons' },
										_react2['default'].createElement(_reactisLoader.LoadingButton, {
											loading: !!(this.props.form && this.props.form.get('saving')),
											title: 'Uložit',
											onClick: function () {
												return _this2.save();
											}
										})
									)
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 983:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _immutable = __webpack_require__(19);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _redux = __webpack_require__(27);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(
						'a',
						{ href: '/emailtemplate/' + row.id, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						val
					)
				);
			};
	
			this.columnModel = [{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			}, {
				name: 'subject',
				title: 'Předmět',
				field: 'subject'
			}, {
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				align: 'center',
				viewport: 'tablet'
			}, {
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: { whiteSpace: 'nowrap' },
				width: 30,
				align: 'center',
				sortable: false,
				viewport: 'tablet',
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/emailtemplate/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' ',
						_react2['default'].createElement(
							'span',
							{ className: 'vp-desktop' },
							'Upravit'
						)
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				fulltext: { 'class': _reactisInputs.SearchInput },
				title: { 'class': _reactisInputs.FilterInput },
				subject: { 'class': _reactisInputs.FilterInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'asc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('emailtemplate.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('emailtemplate.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('emailtemplate', row.title, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.render = function render() {
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'emailtemplate',
				api: 'emailtemplate.getList',
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		}, function (dispatch) {
			return { datagridActions: _redux.bindActionCreators(_reactisDatagrid.actions, dispatch) };
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 984:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(983);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(982);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Page: {
			displayName: 'Page'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Page = (function (_React$Component) {
		_inherits(Page, _React$Component);
	
		function Page() {
			_classCallCheck(this, _Page);
	
			_React$Component.apply(this, arguments);
		}
	
		Page.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'E-mailové šablony' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'emailtemplate',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nová',
					disableAdd: true,
					listTitle: 'E-mailové šablony'
				}, this.props))
			);
		};
	
		var _Page = Page;
		Page = _wrapComponent('_$Page')(Page) || Page;
		return Page;
	})(_react2['default'].Component);
	
	exports['default'] = Page;
	module.exports = exports['default'];

/***/ },

/***/ 985:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _helpersApiClient = __webpack_require__(168);
	
	var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsActionButton = __webpack_require__(105);
	
	var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);
	
	var _componentsSaveButton = __webpack_require__(129);
	
	var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _componentsFormUserLookup = __webpack_require__(243);
	
	var _componentsFormUserLookup2 = _interopRequireDefault(_componentsFormUserLookup);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _MiniList = __webpack_require__(987);
	
	var _MiniList2 = _interopRequireDefault(_MiniList);
	
	var _components = {
		_$ItemSubform: {
			displayName: 'ItemSubform'
		},
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var ItemSubform = (function (_React$Component) {
		_inherits(ItemSubform, _React$Component);
	
		function ItemSubform(props) {
			_classCallCheck(this, _ItemSubform);
	
			_React$Component.call(this, props);
			this.state = {
				overRemove: false
			};
		}
	
		ItemSubform.prototype.handleMouseOver = function handleMouseOver() {
			this.setState({ overRemove: true });
		};
	
		ItemSubform.prototype.handleMouseOut = function handleMouseOut() {
			this.setState({ overRemove: false });
		};
	
		ItemSubform.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				'tr',
				{ className: this.state.overRemove ? 'subformOverRemove' : null },
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement(_reactisForms.FormField, { name: 'title' })
				),
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement(_reactisForms.FormField, { name: 'price' })
				),
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement('i', { title: 'Odstranit',
						onClick: this.props.onRemove,
						onMouseOver: function () {
							return _this.handleMouseOver();
						},
						onMouseOut: function () {
							return _this.handleMouseOut();
						},
						className: 'icon-cross removesubform' })
				)
			);
		};
	
		var _ItemSubform = ItemSubform;
		ItemSubform = _wrapComponent('_$ItemSubform')(ItemSubform) || ItemSubform;
		return ItemSubform;
	})(_react2['default'].Component);
	
	;
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'invoice.fetch',
				save: 'invoice.save',
				remove: 'invoice.delete'
			};
	
			this.changeEvent = 'invoice.change';
	
			this.messages = {
				remove: 'Opravdu si přejete fakturu odstranit?',
				notfound: 'Faktura nenalezena!'
			};
	
			this.schema = {
				number: {
					'class': _reactisInputs.TextInput,
					label: 'Číslo',
					rules: {
						presence: { message: 'Číslo faktury je povinná položka faktury!' }
					}
				},
				client: {
					'class': _componentsFormClientLookup2['default'],
					label: 'Klient'
				},
				date1: {
					'class': _reactisInputs.DatePicker,
					label: 'Datum vystavení',
					value: new _moment2['default']().format('YYYY-MM-DD')
				},
				date2: {
					'class': _reactisInputs.DatePicker,
					label: 'Datum splatnosti'
				},
				items: {
					'class': _reactisForms.Multiform,
					label: 'Položky',
					addLabel: 'přidat položku',
					value: [{ id: -1, title: '' }],
					subform: ItemSubform,
					showHeader: false,
					schema: {
						title: {
							'class': _reactisInputs.TextInput,
							label: 'Text',
							style: { width: 400 } /*,
	                            rules: {
	                            presence: {message: 'Text je povinná položka!'},
	                            length: {
	                            minimum: 5,
	                            message: 'Název musí být delší než 5jeden znak.'
	                            }
	                            }*/
						},
						price: {
							'class': _reactisInputs.Number,
							label: 'Cena',
							style: { width: 80 },
							addonAfter: 'Kč'
						}
					}
				},
				order: {
					'class': _reactisInputs.TextInput,
					label: 'Objednávka'
	
				},
				vs: {
					'class': _reactisInputs.TextInput,
					label: 'Variabilní symbol'
				},
				text: {
					'class': _reactisInputs.TextInput,
					label: 'Popis'
				},
				qrmsg: {
					'class': _reactisInputs.TextInput,
					label: 'QR zpráva'
				},
				status: {
					'class': _reactisInputs.Select,
					options: _dbinfo2['default'].InvoiceStatus.asArray(),
					value: _constants2['default'].INVOICE_STATUS.NEW,
					nullable: false,
					label: 'Stav'
				},
				notice: {
					'class': _reactisInputs.TextArea,
					label: 'Poznámka',
					style: { height: '40px' }
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.form.on('change', function (key, value) {
				if (key == 'number') {
					_this2.title = '#' + value;
				}
				_this2.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: '#' + data.number });
		};
	
		Form.prototype.handleDownload = function handleDownload(toEmail) {
			var api = new _helpersApiClient2['default']();
			api.call('invoice.download', { id: this.props.id, toEmail: toEmail }).then(function (data) {
				if (data) {
					window.location = data.url;
				}
			});
		};
	
		Form.prototype.render = function render() {
			var _this3 = this;
	
			var loading = !!(this.props.form && this.props.form.get('loading'));
			var client = this.props.form && this.props.form.getIn(['values', 'client']) && this.props.form.getIn(['values', 'client']).toJS();
	
			var canEdit = true || this.user.isAllowed('user', 'update');
			var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
				disabled: !canEdit,
				loading: !!(this.props.form && this.props.form.get('saving')),
				onClick: function () {
					return _this3.save();
				}
			});
	
			var printButton = _react2['default'].createElement(
				_reactBootstrap.DropdownButton,
				{ id: 'print', style: { marginLeft: 5 }, bsStyle: 'success', title: _react2['default'].createElement(
						'span',
						null,
						_react2['default'].createElement('i', { className: 'fa fa-print' }),
						' Tisk'
					) },
				_react2['default'].createElement(
					_reactBootstrap.MenuItem,
					{ onSelect: this.handleDownload.bind(this, true), eventKey: '1' },
					'Do e-mailu'
				),
				_react2['default'].createElement(
					_reactBootstrap.MenuItem,
					{ onSelect: this.handleDownload.bind(this, false), eventKey: '2' },
					'Do obálky'
				)
			);
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				saveButton,
				this.props.id > 0 && _react2['default'].createElement(
					_componentsActionButton2['default'],
					{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
							return _this3.remove();
						} },
					'Odstranit'
				),
				this.props.id > 0 && printButton
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Faktura', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-8' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_Object$keys(this.schema).filter(function (key) {
										return ['vs', 'order', 'status'].indexOf(key) == -1;
									}).map(function (key) {
										return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this3.schema[key].visible, name: key, labelWidth: '135' });
									})
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-4' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'vs', labelWidth: '135' }),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'order', labelWidth: '135' }),
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'status', labelWidth: '135' })
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-8' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_react2['default'].createElement(
										_reactisForms.FormRow,
										{ className: 'buttons', labelWidth: '135' },
										saveButton
									)
								)
							)
						),
						client && client.id && _react2['default'].createElement(
							'div',
							{ className: 'col-md-8' },
							_react2['default'].createElement(
								'h5',
								null,
								'Předchozí faktury'
							),
							_react2['default'].createElement(_MiniList2['default'], { client: client && client.id,
								actions: this.props.tabActions,
								id: this.props.tabid
							})
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 986:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _redux = __webpack_require__(27);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _reduxModulesInvoice = __webpack_require__(1058);
	
	var invoiceActions = _interopRequireWildcard(_reduxModulesInvoice);
	
	var _RowItems = __webpack_require__(503);
	
	var _RowItems2 = _interopRequireDefault(_RowItems);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/invoice/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'number',
				title: 'Číslo',
				field: 'number',
				align: 'center',
				width: 70,
				renderer: rendererLink
			}, {
				name: 'date1',
				title: 'Datum',
				field: 'date1',
				width: 115,
				align: 'right',
				viewport: 'tablet',
				renderer: _helpersRenderers2['default'].Date
			}, {
				name: 'client',
				title: 'Klient',
				field: 'client',
				viewport: 'tablet',
				renderer: rendererLink
			}, {
				name: 'price',
				title: 'Cena',
				field: 'price',
				align: 'right',
				width: 100,
				suffix: ' Kč',
				renderer: _helpersRenderers2['default'].Number,
				viewport: 'tablet'
			}, {
				name: 'status',
				title: 'Zapl.',
				field: 'status',
				width: 50,
				align: 'center',
				viewport: 'tablet',
				renderer: _helpersRenderers2['default'].coloredCheck
			}, {
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/invoice/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' Upravit'
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				number: { 'class': _reactisInputs.FilterInput },
				client: { 'class': _componentsFormClientLookup2['default'] },
				date1: { 'class': _componentsFormDateRange2['default'] },
				price: {
					'class': _reactisInputs.Select,
					options: [{ id: 1, title: '< 3 000 Kč' }, {
						id: 2,
						title: '> 3 000 Kč'
					}]
				},
				status: {
					'class': _reactisInputs.Select,
					options: _dbinfo2['default'].YesNo.asArray()
				},
				fulltext: { 'class': _reactisInputs.SearchInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'desc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('invoice.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('invoice.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('invoice', '#' + row.number, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.setStatusPayed = function setStatusPayed(status, action) {
			this.props.invoiceActions.setStatus(action, status).then(function () {
				_EventEmitter2['default'].emit('invoice.change');
			});
		};
	
		List.prototype.render = function render() {
			var _this3 = this;
	
			var buttons = _react2['default'].createElement(
				_reactBootstrap.Button,
				{ href: '/trigger/0', onClick: function (e) {
						return _this3.handleNewClick(e);
					} },
				_react2['default'].createElement('i', { className: 'fa fa-plus' }),
				' Nová faktura'
			);
	
			var actions = [{ title: 'Označit jako zaplacené', onClick: function onClick(action) {
					return _this3.setStatusPayed(2, action);
				} }, { title: 'Označit jako nezaplacené', onClick: function onClick(action) {
					return _this3.setStatusPayed(1, action);
				} }];
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'invoice',
				api: 'invoice.getList',
				multiActions: actions,
				buttons: buttons,
				expandableComponent: _RowItems2['default'],
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				getRowClassName: null,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		}, function (dispatch) {
			return { invoiceActions: _redux.bindActionCreators(invoiceActions, dispatch) };
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 987:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _RowItems = __webpack_require__(503);
	
	var _RowItems2 = _interopRequireDefault(_RowItems);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/invoice/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'number',
				title: 'Číslo',
				field: 'number',
				align: 'center',
				width: 70,
				renderer: rendererLink
			}, {
				name: 'date1',
				title: 'Datum',
				field: 'date1',
				align: 'right',
				viewport: 'tablet',
				renderer: _helpersRenderers2['default'].Date
			}, {
				name: 'price',
				title: 'Cena',
				field: 'price',
				align: 'right',
				width: 100,
				suffix: ' Kč',
				renderer: _helpersRenderers2['default'].Number,
				viewport: 'tablet'
			}, {
				name: 'status',
				title: 'Zapl.',
				field: 'status',
				width: 50,
				align: 'center',
				viewport: 'tablet',
				renderer: _helpersRenderers2['default'].coloredCheck
			}, {
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/invoice/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' })
					);
				}
			}];
			this.defaultSort = { column: 'date1', 'direction': 'desc' };
		}
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('invoice', '#' + row.number, row);
		};
	
		List.prototype.render = function render() {
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				id: this.props.id,
				api: 'invoice.getList',
				expandableComponent: _RowItems2['default'],
				limit: 10,
				disableButtons: true,
				getRowClassName: null,
				fixedFilter: { client: this.props.client },
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 988:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(986);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(985);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Page: {
			displayName: 'Page'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Page = (function (_React$Component) {
		_inherits(Page, _React$Component);
	
		function Page() {
			_classCallCheck(this, _Page);
	
			_React$Component.apply(this, arguments);
		}
	
		Page.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'Faktury' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'invoice',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nová',
					listTitle: 'Seznam faktur'
				}, this.props))
			);
		};
	
		var _Page = Page;
		Page = _wrapComponent('_$Page')(Page) || Page;
		return Page;
	})(_react2['default'].Component);
	
	exports['default'] = Page;
	module.exports = exports['default'];

/***/ },

/***/ 989:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactDocumentMeta = __webpack_require__(216);
	
	var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);
	
	var _reduxModulesAuth = __webpack_require__(130);
	
	var authActions = _interopRequireWildcard(_reduxModulesAuth);
	
	var _utilsUtils = __webpack_require__(247);
	
	var _immutable = __webpack_require__(19);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactisForms = __webpack_require__(23);
	
	var _components = {
		_$Login: {
			displayName: 'Login'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Login = (function (_Component) {
		_inherits(Login, _Component);
	
		_createClass(Login, null, [{
			key: 'contextTypes',
			value: {
				history: _react2['default'].PropTypes.object,
				user: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		function Login() {
			_classCallCheck(this, _Login);
	
			_Component.call(this);
			this.schema = {
				username: {
					'class': _reactisForms.TextInput,
					label: 'Login',
					placeholder: 'Uživatelské jméno',
					className: 'form-control',
					rules: {
						presence: { message: 'Zadejte přihlašovací jméno!' }
					}
				},
				password: {
					'class': _reactisForms.TextInput,
					type: 'password',
					placeholder: 'Heslo',
					className: 'form-control password',
					label: 'Heslo',
					rules: {
						presence: { message: 'Zadejte heslo!' }
					}
				},
				remember: {
					'class': _reactisForms.Checkbox,
					className: "styled"
				}
			};
		}
	
		Login.prototype.componentWillMount = function componentWillMount() {
			$(document.body).addClass('login');
			if (this.props.user) {
				this.context.history.replaceState(null, '/');
			}
		};
	
		Login.prototype.componentWillUnmount = function componentWillUnmount() {
			$(document.body).removeClass('login');
		};
	
		Login.prototype.handleSubmit = function handleSubmit(form) {
			var values = form.getValues().toJS();
			this.props.login(values);
		};
	
		Login.prototype.render = function render() {
	
			return _react2['default'].createElement(
				'div',
				{ className: 'page-container login-container', style: { minHeight: _utilsUtils.getWindowSize().height * 0.9 } },
				_react2['default'].createElement(
					'div',
					{ className: 'page-content' },
					_react2['default'].createElement(
						'div',
						{ className: 'content-wrapper' },
						_react2['default'].createElement(
							_reactisForms.RxForm,
							{ ref: 'form', id: 'login', schema: this.schema, className: 'form-login', onSubmit: this.handleSubmit.bind(this) },
							_react2['default'].createElement(
								'div',
								{ className: 'panel panel-body login-form' },
								_react2['default'].createElement(
									'div',
									{ className: 'text-center' },
									_react2['default'].createElement(
										'div',
										{ className: 'icon-object border-slate-300 text-slate-300' },
										_react2['default'].createElement('i', { className: 'icon-reading' })
									),
									_react2['default'].createElement(
										'h5',
										{ className: 'content-group' },
										'Přihlášení do CRM',
										_react2['default'].createElement(
											'small',
											{ className: 'display-block' },
											'Zadejte uživatelské jméno a heslo.'
										)
									)
								),
								this.props.error && _react2['default'].createElement(
									'div',
									{ className: 'errorHandler alert alert-danger' },
									this.props.error
								),
								_react2['default'].createElement(
									'div',
									{ className: 'form-group has-feedback has-feedback-left' },
									_react2['default'].createElement(_reactisForms.FormField, { name: 'username' }),
									_react2['default'].createElement(
										'div',
										{ className: 'form-control-feedback' },
										_react2['default'].createElement('i', { className: 'icon-user text-muted' })
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: 'form-group has-feedback has-feedback-left' },
									_react2['default'].createElement(_reactisForms.FormField, { name: 'password' }),
									_react2['default'].createElement(
										'div',
										{ className: 'form-control-feedback' },
										_react2['default'].createElement('i', { className: 'icon-lock2 text-muted' })
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: 'form-group login-options' },
									_react2['default'].createElement(
										'div',
										{ className: 'row' },
										_react2['default'].createElement(
											'div',
											{ className: 'col-sm-12' },
											_react2['default'].createElement(
												'label',
												{ className: 'checkbox-inline' },
												_react2['default'].createElement(_reactisForms.FormField, { name: 'remember' }),
												'Pamatovat přihlášení'
											)
										),
										_react2['default'].createElement(
											'div',
											{ className: 'col-sm-6 text-right hide' },
											_react2['default'].createElement(
												'a',
												{ href: 'login_password_recover.html' },
												'Forgot password?'
											)
										)
									)
								),
								_react2['default'].createElement(
									'div',
									{ className: 'form-group' },
									_react2['default'].createElement(
										'button',
										{ type: 'submit', className: 'btn bg-blue btn-block' },
										'Přihlásit ',
										_react2['default'].createElement('i', { className: 'icon-arrow-right14 position-right' })
									)
								)
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ style: { backgroundColor: '#E4EFEF', padding: '4px 12px', fontSize: 12, position: 'fixed', bottom: 10, right: 10, opacity: 0.6 } },
					_react2['default'].createElement(
						'span',
						{ style: { color: '#444' } },
						'Powered by'
					),
					' ',
					_react2['default'].createElement(
						'a',
						{ target: '_blank', style: { color: '#444' }, href: 'http://www.reactis.cz' },
						'React',
						_react2['default'].createElement(
							'span',
							{ style: { color: '#900' } },
							'is'
						)
					)
				)
			);
		};
	
		var _Login = Login;
		Login = _wrapComponent('_$Login')(Login) || Login;
		Login = _reactRedux.connect(function (state) {
			return { user: state.auth.user, error: state.auth.loginError };
		}, authActions)(Login) || Login;
		return Login;
	})(_react.Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ },

/***/ 990:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	exports.__esModule = true;
	exports["default"] = NotFound;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function NotFound() {
	  return _react2["default"].createElement(
	    "div",
	    { className: "container-fluid text-center" },
	    _react2["default"].createElement("br", null),
	    _react2["default"].createElement("br", null),
	    _react2["default"].createElement(
	      "h1",
	      { className: "error-title" },
	      "404"
	    ),
	    _react2["default"].createElement(
	      "h6",
	      { className: "text-semibold content-group" },
	      "Oops, an error has occurred. Page not found!"
	    )
	  );
	}
	
	module.exports = exports["default"];

/***/ },

/***/ 991:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsActionButton = __webpack_require__(105);
	
	var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);
	
	var _componentsSaveButton = __webpack_require__(129);
	
	var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _components = {
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'project.fetch',
				save: 'project.save',
				remove: 'project.delete'
			};
	
			this.changeEvent = 'project.change';
	
			this.messages = {
				remove: 'Opravdu si přejete projekt odstranit?',
				notfound: 'Projekt nenalezen!'
			};
	
			this.schema = {
				title: {
					'class': _reactisInputs.TextInput,
					label: 'Název',
					autoFocus: !props.id,
					rules: {
						presence: { message: 'Název je povinná položka!' }
					}
				},
				client: {
					'class': _componentsFormClientLookup2['default'],
					label: 'Klient'
				},
				image: {
					'class': _reactisInputs.ImageUpload,
					label: 'Logo'
				},
				active: {
					'class': _reactisInputs.Checkbox,
					label: 'Aktivní'
				},
				notice: {
					'class': _reactisInputs.TextInput,
					label: 'Poznámka'
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this = this;
	
			this.form.on('change', function (key, value) {
				if (key == 'title') {
					_this.title = value;
				}
				_this.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: data.title });
		};
	
		Form.prototype.render = function render() {
			var _this2 = this;
	
			var canEdit = true;
	
			var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
				disabled: !canEdit,
				loading: !!(this.props.form && this.props.form.get('saving')),
				onClick: function () {
					return _this2.save();
				}
			});
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				saveButton,
				this.props.id > 0 && _react2['default'].createElement(
					_componentsActionButton2['default'],
					{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
							return _this2.remove();
						} },
					'Odstranit'
				)
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Projekt', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-6' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_Object$keys(this.schema).map(function (key) {
										return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
									}),
									_react2['default'].createElement(
										_reactisForms.FormRow,
										{ className: 'buttons' },
										saveButton
									)
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 992:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _redux = __webpack_require__(27);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/project/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			}, {
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				align: 'center',
				viewport: 'tablet'
			},
			/*{
	  	name: 'active',
	  	title: 'Aktivní',
	  	field: 'active',
	  	width: 60,
	  	align: 'center',
	  	viewport: 'tablet',
	  	renderer: Renderers.coloredCheck
	  },*/
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/project/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' Upravit'
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				title: { 'class': _reactisInputs.FilterInput },
				fulltext: { 'class': _reactisInputs.SearchInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'asc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : { active: '1' };
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('project.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('project.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('project', row.title, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.render = function render() {
			var _this3 = this;
	
			var buttons = _react2['default'].createElement(
				_reactBootstrap.Button,
				{ href: '/project/0', onClick: function (e) {
						return _this3.handleNewClick(e);
					} },
				_react2['default'].createElement('i', { className: 'fa fa-plus' }),
				' Nový projekt'
			);
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'project',
				api: 'project.getList',
				buttons: buttons,
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				getRowClassName: null,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 993:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(992);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(991);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Page: {
			displayName: 'Page'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Page = (function (_React$Component) {
		_inherits(Page, _React$Component);
	
		function Page() {
			_classCallCheck(this, _Page);
	
			_React$Component.apply(this, arguments);
		}
	
		Page.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'Projekty' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'project',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nový',
					listTitle: 'Seznam projektů'
				}, this.props))
			);
		};
	
		var _Page = Page;
		Page = _wrapComponent('_$Page')(Page) || Page;
		return Page;
	})(_react2['default'].Component);
	
	exports['default'] = Page;
	module.exports = exports['default'];

/***/ },

/***/ 994:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsActionButton = __webpack_require__(105);
	
	var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);
	
	var _componentsSaveButton = __webpack_require__(129);
	
	var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _componentsFormUserLookup = __webpack_require__(243);
	
	var _componentsFormUserLookup2 = _interopRequireDefault(_componentsFormUserLookup);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components = {
		_$WorkSubform: {
			displayName: 'WorkSubform'
		},
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var WorkSubform = (function (_React$Component) {
		_inherits(WorkSubform, _React$Component);
	
		function WorkSubform(props) {
			_classCallCheck(this, _WorkSubform);
	
			_React$Component.call(this, props);
			this.state = {
				overRemove: false
			};
		}
	
		WorkSubform.prototype.handleMouseOver = function handleMouseOver() {
			this.setState({ overRemove: true });
		};
	
		WorkSubform.prototype.handleMouseOut = function handleMouseOut() {
			this.setState({ overRemove: false });
		};
	
		WorkSubform.prototype.render = function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				'tr',
				{ className: this.state.overRemove ? 'subformOverRemove' : null },
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement(_reactisForms.FormField, { name: 'date' })
				),
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement(_reactisForms.FormField, { name: 'time' })
				),
				_react2['default'].createElement(
					'td',
					null,
					_react2['default'].createElement('i', { title: 'Odstranit',
						onClick: this.props.onRemove,
						onMouseOver: function () {
							return _this.handleMouseOver();
						},
						onMouseOut: function () {
							return _this.handleMouseOut();
						},
						className: 'icon-cross removesubform' })
				)
			);
		};
	
		var _WorkSubform = WorkSubform;
		WorkSubform = _wrapComponent('_$WorkSubform')(WorkSubform) || WorkSubform;
		return WorkSubform;
	})(_react2['default'].Component);
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'ticket.fetch',
				save: 'ticket.save',
				remove: 'ticket.delete'
			};
	
			this.changeEvent = 'ticket.change';
	
			this.messages = {
				remove: 'Opravdu si přejete požadavek odstranit?',
				notfound: 'Požadavek nenalezen!'
			};
	
			this.schema = {
				title: {
					'class': _reactisInputs.TextInput,
					label: 'Název',
					rules: {
						presence: { message: 'Předmět je povinná položka požadavku!' },
						length: {
							maximum: 255,
							message: 'Povolená délka předmětu je 255 znaků.'
						}
					}
				},
				client: {
					'class': _componentsFormClientLookup2['default'],
					label: 'Klient'
				},
				redmine_id: {
					'class': _reactisInputs.TextInput,
					label: 'Redmine #'
				},
				responsible: {
					'class': _componentsFormUserLookup2['default'],
					label: 'Řešitel'
				},
				text: {
					'class': _reactisInputs.CKEditor,
					label: 'Popis',
					height: 120,
					width: '100%',
					toolbar: [["Bold", "Italic", "-", "NumberedList", "BulletedList", "-", "Link", "Unlink"]]
				},
				/*created: {
	   	class: DatePicker,
	   	label: 'Dokončení do'
	   },*/
				status: {
					'class': _reactisInputs.Select,
					options: _dbinfo2['default'].TicketStatus.asArray(),
					clearable: false,
					label: 'Stav',
					value: 1
				},
				archive: {
					'class': _reactisInputs.Checkbox,
					label: 'Archiv'
				},
				notice: {
					'class': _reactisInputs.TextArea,
					label: 'Poznámka',
					style: { height: '60px' }
				},
				items: {
					'class': _reactisForms.Multiform,
					label: 'Činnosti',
					addLabel: 'přidat činnost',
					value: [{ id: -1, date: new _moment2['default']().format('YYYY-MM-DD') }],
					subform: WorkSubform,
					showHeader: true,
					schema: {
						date: {
							'class': _reactisInputs.DatePicker,
							label: 'Datum',
							value: new _moment2['default']().format('YYYY-MM-DD')
						},
						time: {
							'class': _reactisInputs.TimeInput,
							label: 'Čas',
							style: { width: 55 },
							addonAfter: 'hh:mm'
						}
					}
				}
	
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.form.on('change', function (key, value) {
				if (key == 'title') {
					_this2.title = value;
				}
				_this2.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: data.title });
		};
	
		Form.prototype.render = function render() {
			var _this3 = this;
	
			var loading = !!(this.props.form && this.props.form.get('loading'));
	
			var canEdit = true || this.user.isAllowed('user', 'update');
			var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
				disabled: !canEdit,
				loading: !!(this.props.form && this.props.form.get('saving')),
				onClick: function () {
					return _this3.save();
				}
			});
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				saveButton,
				this.props.id > 0 && _react2['default'].createElement(
					_componentsActionButton2['default'],
					{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
							return _this3.remove();
						} },
					'Odstranit'
				)
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Požadavek', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-6' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_Object$keys(this.schema).filter(function (key) {
										return ['items'].indexOf(key) == -1;
									}).map(function (key) {
										return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this3.schema[key].visible, name: key, labelWidth: '135' });
									}),
									_react2['default'].createElement(
										_reactisForms.FormRow,
										{ className: 'buttons' },
										saveButton
									)
								)
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-6' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_react2['default'].createElement(_reactisForms.FormRow, { name: 'items', labelWidth: '135' })
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 995:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _redux = __webpack_require__(27);
	
	var _componentsFormClientLookup = __webpack_require__(89);
	
	var _componentsFormClientLookup2 = _interopRequireDefault(_componentsFormClientLookup);
	
	var _componentsFormUserLookup = __webpack_require__(243);
	
	var _componentsFormUserLookup2 = _interopRequireDefault(_componentsFormUserLookup);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/ticket/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'created',
				title: 'Vytvořeno',
				field: 'created',
				width: 115,
				align: 'right',
				renderer: _helpersRenderers2['default'].Date,
				viewport: 'desktop'
			}, {
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			}, {
				name: 'redmine_id',
				title: 'Redmine',
				field: 'redmine_id',
				width: 80
			}, {
				name: 'time',
				title: 'Čas',
				field: 'time',
				viewport: 'tablet',
				align: 'right',
				renderer: _helpersRenderers2['default'].Time
			}, {
				name: 'client',
				title: 'Klient',
				field: 'client',
				viewport: 'tablet'
			}, {
				name: 'responsible',
				title: 'Řešitel',
				field: 'responsible',
				width: 140,
				viewport: 'tablet'
			}, {
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				align: 'center',
				viewport: 'tablet'
			},
			/*{
	   name: 'active',
	   title: 'Aktivní',
	   field: 'active',
	   width: 60,
	   align: 'center',
	   viewport: 'tablet',
	   renderer: Renderers.coloredCheck
	   },*/
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/ticket/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' Upravit'
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				title: { 'class': _reactisInputs.FilterInput },
				redmine_id: { 'class': _reactisInputs.FilterInput },
				created: { 'class': _componentsFormDateRange2['default'] },
				client: { 'class': _componentsFormClientLookup2['default'] },
				responsible: { 'class': _componentsFormUserLookup2['default'] },
				active: { 'class': _reactisInputs.Select, value: '1', options: [{ id: '1', title: 'Ano' }, { id: '0', title: 'Ne' }] },
				fulltext: { 'class': _reactisInputs.SearchInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'desc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : { active: '1' };
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('ticket.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('ticket.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('ticket', row.title, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.render = function render() {
			var _this3 = this;
	
			var buttons = _react2['default'].createElement(
				_reactBootstrap.Button,
				{ href: '/project/0', onClick: function (e) {
						return _this3.handleNewClick(e);
					} },
				_react2['default'].createElement('i', { className: 'fa fa-plus' }),
				' Nový požadavek'
			);
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'ticket',
				api: 'ticket.getList',
				buttons: buttons,
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				getRowClassName: null,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 996:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(995);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(994);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Page: {
			displayName: 'Page'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Page = (function (_React$Component) {
		_inherits(Page, _React$Component);
	
		function Page() {
			_classCallCheck(this, _Page);
	
			_React$Component.apply(this, arguments);
		}
	
		Page.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'Požadavky' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'ticket',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nový',
					listTitle: 'Seznam požadavků'
				}, this.props))
			);
		};
	
		var _Page = Page;
		Page = _wrapComponent('_$Page')(Page) || Page;
		return Page;
	})(_react2['default'].Component);
	
	exports['default'] = Page;
	module.exports = exports['default'];

/***/ },

/***/ 997:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var Constants = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsActionButton = __webpack_require__(105);
	
	var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);
	
	var _componentsSaveButton = __webpack_require__(129);
	
	var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);
	
	var _components = {
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Form = (function (_FormDB) {
		_inherits(Form, _FormDB);
	
		function Form(props, context) {
			_classCallCheck(this, _Form);
	
			_FormDB.call(this, props, context);
	
			this.api = {
				fetch: 'user.fetch',
				save: 'user.save',
				remove: 'user.delete'
			};
	
			this.changeEvent = 'user.change';
	
			this.messages = {
				remove: 'Opravdu si přejete uživatele odstranit?',
				notfound: 'Uživatel nenalezen!'
			};
	
			this.schema = {
				name: {
					'class': _reactisInputs.TextInput,
					label: 'Jméno',
					rules: {
						presence: { message: 'Jméno je povinná položka!' }
					}
				},
				surname: {
					'class': _reactisInputs.TextInput,
					label: 'Příjmení',
					rules: {
						presence: { message: 'Příjmení je povinná položka!' }
					}
				},
				email: {
					'class': _reactisInputs.TextInput,
					label: 'E-mail',
					value: '@',
					rules: {
						email: { message: 'Zadejte platný e-mail!' }
					}
				},
				active: {
					'class': _reactisInputs.Checkbox,
					label: 'Aktivní',
					value: true
				},
				login: {
					'class': _reactisInputs.TextInput,
					label: 'Přihlašovací jméno',
					visible: function visible(form) {
						return form.active;
					}
				},
				password: {
					'class': _reactisInputs.TextInput,
					type: 'password',
					label: 'Heslo',
					visible: function visible(form) {
						return form.active;
					}
				},
				passwordConfirm: {
					'class': _reactisInputs.TextInput,
					type: 'password',
					label: 'Heslo pro kontrolu',
					visible: function visible(form) {
						return form.active;
					},
					rules: {
						equality: {
							attribute: 'password',
							message: 'Hesla se musejí shodovat!'
						}
					}
				},
				image: {
					'class': _reactisInputs.ImageUpload,
					label: 'Foto'
				},
				notice: {
					'class': _reactisInputs.TextArea,
					label: 'Poznámka',
					style: { height: '60px' }
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.componentDidMount = function componentDidMount() {
			var _this = this;
	
			this.form.on('change', function (key, value, values) {
				if (key == 'name' || key == 'surname') {
					_this.title = (values.get('name') ? values.get('name') : '') + ' ' + (values.get('surname') ? values.get('surname') : '');
				}
				_this.changed = true;
			});
			_FormDB.prototype.componentDidMount.call(this);
		};
	
		Form.prototype.updateTab = function updateTab(data) {
			this.props.updateTab({ title: data.name + ' ' + data.surname });
		};
	
		Form.prototype.render = function render() {
			var _this2 = this;
	
			var loading = !!(this.props.form && this.props.form.get('loading'));
	
			var canEdit = true || this.user.isAllowed('user', 'update');
			var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
				disabled: !canEdit,
				loading: !!(this.props.form && this.props.form.get('saving')),
				onClick: function () {
					return _this2.save();
				}
			});
	
			var btns = _react2['default'].createElement(
				_reactBootstrap.ButtonToolbar,
				null,
				saveButton,
				this.props.id > 0 && _react2['default'].createElement(
					_componentsActionButton2['default'],
					{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
							return _this2.remove();
						} },
					'Odstranit'
				)
			);
	
			return _react2['default'].createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
				_react2['default'].createElement(
					_reactisForms.RxForm,
					{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
					_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Uživatel', buttons: btns }),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-md-6' },
							_react2['default'].createElement(
								'table',
								{ className: 'form' },
								_react2['default'].createElement(
									'tbody',
									null,
									_Object$keys(this.schema).map(function (key) {
										return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
									}),
									_react2['default'].createElement(
										_reactisForms.FormRow,
										{ className: 'buttons' },
										saveButton
									)
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				form: state.forms.get('tab_' + props.tabid)
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
		}, null, { withRef: true })(Form) || Form;
		return Form;
	})(_componentsFormDB2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 998:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _componentsDatagrid = __webpack_require__(87);
	
	var _componentsDatagrid2 = _interopRequireDefault(_componentsDatagrid);
	
	var _helpersRenderers = __webpack_require__(93);
	
	var _helpersRenderers2 = _interopRequireDefault(_helpersRenderers);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisModal = __webpack_require__(29);
	
	var _EventEmitter = __webpack_require__(79);
	
	var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
	
	var _componentsFormDateRange = __webpack_require__(90);
	
	var _componentsFormDateRange2 = _interopRequireDefault(_componentsFormDateRange);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(20);
	
	var _componentsFormActiveSelect = __webpack_require__(88);
	
	var _componentsFormActiveSelect2 = _interopRequireDefault(_componentsFormActiveSelect);
	
	var _redux = __webpack_require__(27);
	
	var _components = {
		_$List: {
			displayName: 'List'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var List = (function (_Component) {
		_inherits(List, _Component);
	
		function List(props, context) {
			var _this = this;
	
			_classCallCheck(this, _List);
	
			_Component.call(this, props);
	
			var rendererLink = function rendererLink(val, row) {
				return _react2['default'].createElement(
					'a',
					{ href: '/user/' + row.id, onClick: function (e) {
							return _this.handleOpen(row, e);
						} },
					val
				);
			};
	
			this.columnModel = [{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				viewport: 'tablet',
				align: 'center'
			}, {
				name: 'image',
				title: 'Foto',
				field: 'image',
				sortable: false,
				width: 60,
				viewport: 'tablet',
				align: 'center',
				renderer: function renderer(val) {
					if (val) {
						return _react2['default'].createElement('img', { src: val.url, style: { height: val.height, width: val.width } });
					}
				}
			}, {
				name: 'name',
				title: 'Jméno',
				field: 'name',
				renderer: rendererLink
			}, {
				name: 'surname',
				title: 'Příjmení',
				field: 'surname',
				renderer: rendererLink
			}, {
				name: 'email',
				title: 'E-mail',
				field: 'email',
				viewport: 'tablet'
			}, {
				name: 'active',
				title: 'Aktivní',
				field: 'active',
				width: 60,
				align: 'center',
				viewport: 'tablet',
				renderer: _helpersRenderers2['default'].coloredCheck
			}, {
				name: 'edit',
				title: 'Edit',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: function renderer(val, row) {
					return _react2['default'].createElement(
						'a',
						{ href: '/user/' + val, onClick: function (e) {
								return _this.handleOpen(row, e);
							} },
						_react2['default'].createElement('i', { className: 'fa fa-pencil' }),
						' Upravit'
					);
				}
			}];
	
			var filterSchema = {
				id: { 'class': _reactisInputs.FilterInput },
				name: { 'class': _reactisInputs.FilterInput },
				surname: { 'class': _reactisInputs.FilterInput },
				email: { 'class': _reactisInputs.FilterInput },
				image: { 'class': _reactisInputs.Select, options: [{ id: '1', title: 'Má' }, { id: '0', title: 'Nemá' }], placeholder: '---' },
				active: { 'class': _reactisInputs.Select, options: [{ id: '1', title: 'Ano' }, { id: '0', title: 'Ne' }], placeholder: '---' },
				fulltext: { 'class': _reactisInputs.SearchInput },
				edit: {
					'class': _reactisDatagrid.FilterResetButton,
					visible: function visible() {
						return _this.filter.isChanged();
					},
					onClick: function onClick() {
						return _this.filter.reset();
					}
				}
			};
			this.filter = new _reactisForms.FormManager(filterSchema);
			this.defaultSort = this.props.defaultState ? this.props.defaultState.sort : { column: 'id', 'direction': 'asc' };
			this.defaultFilter = this.props.defaultState ? this.props.defaultState.filter : {};
		}
	
		List.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			this.changeListener = function () {
				_this2.refs.datagrid.getWrappedInstance().refresh();
			};
			_EventEmitter2['default'].on('user.change', this.changeListener);
		};
	
		List.prototype.componentWillUnmount = function componentWillUnmount() {
			_EventEmitter2['default'].removeListener('user.change', this.changeListener);
		};
	
		List.prototype.handleOpen = function handleOpen(row, e) {
			e.preventDefault();
			this.props.actions.openTabForm('user', row.title, row);
		};
	
		List.prototype.handleNewClick = function handleNewClick(e) {
			e.preventDefault();
			this.props.onNewTab();
		};
	
		List.prototype.render = function render() {
			var _this3 = this;
	
			var buttons = _react2['default'].createElement(
				_reactBootstrap.Button,
				{ href: '/user/0', onClick: function (e) {
						return _this3.handleNewClick(e);
					} },
				_react2['default'].createElement('i', { className: 'fa fa-plus' }),
				' Nový uživatel'
			);
	
			return _react2['default'].createElement(_componentsDatagrid2['default'], {
				ref: 'datagrid',
				id: 'user',
				api: 'user.getList',
				buttons: buttons,
				filters: ['fulltext'],
				filter: this.filter,
				saveState: true,
				columnModel: this.columnModel,
				defaultFilter: this.defaultFilter,
				defaultSort: this.defaultSort
			});
		};
	
		var _List = List;
		List = _wrapComponent('_$List')(List) || List;
		List = _reactRedux.connect(function (state, props) {
			return {
				defaultState: state.datagridDefaultState[props.module]
			};
		})(List) || List;
		return List;
	})(_componentsComponent2['default']);
	
	exports['default'] = List;
	module.exports = exports['default'];

/***/ },

/***/ 999:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(998);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(997);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _componentsTabbablePage = __webpack_require__(106);
	
	var _componentsTabbablePage2 = _interopRequireDefault(_componentsTabbablePage);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$UserPage: {
			displayName: 'UserPage'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var UserPage = (function (_React$Component) {
		_inherits(UserPage, _React$Component);
	
		function UserPage() {
			_classCallCheck(this, _UserPage);
	
			_React$Component.apply(this, arguments);
		}
	
		UserPage.prototype.render = function render() {
			return _react2['default'].createElement(
				_reactDocumentTitle2['default'],
				{ title: 'Uživatelé' },
				_react2['default'].createElement(_componentsTabbablePage2['default'], _extends({
					module: 'user',
					List: _List2['default'],
					Form: _Form2['default'],
					newTitle: 'Nový',
					listTitle: 'Seznam uživatelů'
				}, this.props))
			);
		};
	
		var _UserPage = UserPage;
		UserPage = _wrapComponent('_$UserPage')(UserPage) || UserPage;
		return UserPage;
	})(_react2['default'].Component);
	
	exports['default'] = UserPage;
	module.exports = exports['default'];

/***/ },

/***/ 1000:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(4)['default'];
	
	var _createClass = __webpack_require__(9)['default'];
	
	var _classCallCheck = __webpack_require__(3)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$keys = __webpack_require__(24)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	var _interopRequireWildcard = __webpack_require__(32)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsComponent = __webpack_require__(21);
	
	var _componentsComponent2 = _interopRequireDefault(_componentsComponent);
	
	var _dbinfo = __webpack_require__(43);
	
	var _dbinfo2 = _interopRequireDefault(_dbinfo);
	
	var _constants = __webpack_require__(38);
	
	var c = _interopRequireWildcard(_constants);
	
	var _componentsToolbar = __webpack_require__(92);
	
	var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);
	
	var _reactBootstrap = __webpack_require__(14);
	
	var _reactisForms = __webpack_require__(23);
	
	var _reactisInputs = __webpack_require__(39);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(27);
	
	var _reactisModal = __webpack_require__(29);
	
	var _reactisLoader = __webpack_require__(80);
	
	var _componentsFormDB = __webpack_require__(91);
	
	var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);
	
	var _reduxModulesProfile = __webpack_require__(510);
	
	var actions = _interopRequireWildcard(_reduxModulesProfile);
	
	var _reactDocumentTitle = __webpack_require__(37);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _components = {
		_$Form: {
			displayName: 'Form'
		}
	};
	
	function _wrapComponent(uniqueId) {
		return function (ReactClass) {
			return ReactClass;
		};
	}
	
	var Form = (function (_Component) {
		_inherits(Form, _Component);
	
		_createClass(Form, null, [{
			key: 'contextTypes',
			value: {
				store: _react2['default'].PropTypes.object
			},
			enumerable: true
		}]);
	
		function Form(props) {
			_classCallCheck(this, _Form);
	
			_Component.call(this, props);
			this.schema = {
				oldpassword: {
					'class': _reactisInputs.TextInput,
					type: 'password',
					label: 'Aktuální heslo',
					autoComplete: 'off',
					rules: {
						presence: { message: 'Zadejte aktuální heslo!' }
					}
				},
				password: {
					'class': _reactisInputs.TextInput,
					type: 'password',
					label: 'Nové heslo',
					autoComplete: 'off',
					rules: {
						presence: { message: 'Zadejte nové heslo!' }
					}
				},
				passwordConfirm: {
					'class': _reactisInputs.TextInput,
					type: 'password',
					label: 'Heslo pro kontrolu',
					autoComplete: 'off',
					rules: {
						equality: {
							attribute: 'password',
							message: 'Hesla se musejí shodovat!'
						}
					}
				}
			};
			this.form = new _reactisForms.FormManager(this.schema);
		}
	
		Form.prototype.save = function save() {
			var _this = this;
	
			var close = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
			var errors = this.refs.form.getWrappedInstance().validate();
			if (errors) {
				this.displayErrors(errors);
			} else {
				var data = _extends({}, this.form.getValues().toJS());
				this.props.actions.save(data).then(function (action) {
					if (action.error) {
						if (action.error.code == 1001) {
							var _errors = JSON.parse(action.error.message);
							_this.displayErrors(_errors);
						} else {
							if (action.error.message) {
								alert(action.error.message);
							}
						}
					} else {
						_this.form.reset();
					}
				});
			}
		};
	
		Form.prototype.displayErrors = function displayErrors(errors) {
			var messages = [];
			_Object$keys(errors).forEach(function (key) {
				if (errors[key].childs) {
					errors[key].childs.forEach(function (child) {
						_Object$keys(child.errors).forEach(function (key2) {
							messages.push(child.errors[key2][0]);
						});
					});
				} else {
					messages.push(errors[key][0]);
				}
			});
			var alert = new _reactisModal.AlertWindow('Chyba formuláře', messages.map(function (m) {
				return _react2['default'].createElement(
					'span',
					{ key: m },
					m,
					_react2['default'].createElement('br', null)
				);
			}));
			alert.show(this.context.store.dispatch);
		};
	
		Form.prototype.render = function render() {
			var _this2 = this;
	
			return _react2['default'].createElement(
				'div',
				{ className: 'tdidocument' },
				_react2['default'].createElement(_reactDocumentTitle2['default'], { title: 'Můj profil' }),
				_react2['default'].createElement(
					'div',
					{ className: 'page-header content-group' },
					_react2['default'].createElement(
						'div',
						{ className: 'page-header-content' },
						_react2['default'].createElement(
							'h5',
							null,
							_react2['default'].createElement('i', { className: 'icon-user position-left' }),
							_react2['default'].createElement(
								'span',
								{ className: 'text-semibold' },
								'Můj profil'
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: 'panel', style: { paddingBottom: 0 } },
					_react2['default'].createElement(
						'div',
						{ style: { padding: 20 } },
						_react2['default'].createElement(
							'div',
							{ style: { position: 'relative' } },
							_react2['default'].createElement(
								_reactisForms.RxForm,
								{ ref: 'form', form: this.form, id: 'profile' },
								_react2['default'].createElement(
									'div',
									{ className: 'row' },
									_react2['default'].createElement(
										'div',
										{ className: 'col-md-6' },
										_react2['default'].createElement(
											'table',
											{ className: 'form' },
											_react2['default'].createElement(
												'tbody',
												null,
												_Object$keys(this.schema).map(function (key) {
													return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
												}),
												_react2['default'].createElement(
													'tr',
													{ className: 'buttons' },
													_react2['default'].createElement('td', { style: { width: 135 } }),
													_react2['default'].createElement(
														'td',
														null,
														_react2['default'].createElement(_reactisLoader.LoadingButton, {
															loading: !!(this.props.form && this.props.form.get('saving')),
															title: 'Uložit',
															onClick: function () {
																return _this2.save();
															}
														})
													)
												)
											)
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		var _Form = Form;
		Form = _wrapComponent('_$Form')(Form) || Form;
		Form = _reactRedux.connect(function (state, props) {
			return {
				//rxform: state.forms.get('profile')
				form: state.profile
			};
		}, function (dispatch) {
			return { actions: _redux.bindActionCreators(actions, dispatch) };
		})(Form) || Form;
		return Form;
	})(_componentsComponent2['default']);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },

/***/ 1001:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = makeRouteHooksSafe;
	
	var _reactRouterLibRouteUtils = __webpack_require__(63);
	
	// Wrap the hooks so they don't fire if they're called before
	// the store is initialised. This only happens when doing the first
	// client render of a route that has an onEnter hook
	function makeHooksSafe(routes, store) {
	  if (Array.isArray(routes)) {
	    return routes.map(function (route) {
	      return makeHooksSafe(route, store);
	    });
	  }
	
	  var onEnter = routes.onEnter;
	
	  if (onEnter) {
	    routes.onEnter = function safeOnEnter() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      try {
	        store.getState();
	      } catch (err) {
	        if (onEnter.length === 3) {
	          args[2]();
	        }
	
	        // There's no store yet so ignore the hook
	        return;
	      }
	
	      onEnter.apply(null, args);
	    };
	  }
	
	  if (routes.childRoutes) {
	    makeHooksSafe(routes.childRoutes, store);
	  }
	
	  if (routes.indexRoute) {
	    makeHooksSafe(routes.indexRoute, store);
	  }
	
	  return routes;
	}
	
	function makeRouteHooksSafe(_getRoutes) {
	  return function (store) {
	    return makeHooksSafe(_reactRouterLibRouteUtils.createRoutes(_getRoutes(store)), store);
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1002:
/***/ function(module, exports) {

	'use strict';
	
	var time2string = function time2string(value) {
		if (value == null || typeof value == 'undefined') {
			return '';
		}
		var hours = Math.floor(value / 60);
		var mins = value - hours * 60;
		return hours + ':' + (mins < 10 ? '0' : '') + Math.round(mins);
	};
	
	var string2time = function string2time(value) {
		if (value == null || typeof value == 'undefined') {
			return null;
		}
		var arr = value.split(':');
		var hours = parseInt(arr[0]);
		var mins = arr[1] ? parseInt(arr[1]) : 0;
		return hours * 60 + mins;
	};
	
	exports.string2time = string2time;
	exports.time2string = time2string;

/***/ },

/***/ 1052:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	exports['default'] = createStore;
	
	var _redux = __webpack_require__(27);
	
	var _middlewareClientMiddleware = __webpack_require__(1053);
	
	var _middlewareClientMiddleware2 = _interopRequireDefault(_middlewareClientMiddleware);
	
	var _middlewareUrlMiddleware = __webpack_require__(1054);
	
	var _middlewareUrlMiddleware2 = _interopRequireDefault(_middlewareUrlMiddleware);
	
	// import transitionMiddleware from './middleware/transitionMiddleware';
	
	function createStore(client, history, data) {
	  var middleware = [_middlewareClientMiddleware2['default'](client), _middlewareUrlMiddleware2['default'](history)];
	
	  var finalCreateStore = undefined;
	  if (false) {
	    var _require = require('redux-devtools');
	
	    var persistState = _require.persistState;
	
	    var DevTools = require('../components/DevTools/DevTools');
	    finalCreateStore = _redux.compose(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
	  } else {
	    finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
	  }
	
	  var reducer = __webpack_require__(1060);
	  var store = finalCreateStore(reducer, data);
	
	  if (false) {
	    module.hot.accept('./modules/reducer', function () {
	      store.replaceReducer(require('./modules/reducer'));
	    });
	  }
	
	  return store;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1053:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(17)['default'];
	
	exports.__esModule = true;
	exports['default'] = clientMiddleware;
	
	function clientMiddleware(client) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState);
	        }
	
	        var promise = action.promise;
	        var types = action.types;
	
	        var rest = _objectWithoutProperties(action, ['promise', 'types']);
	
	        // eslint-disable-line no-redeclare
	        if (!promise) {
	          return next(action);
	        }
	
	        var REQUEST = types[0];
	        var SUCCESS = types[1];
	        var FAILURE = types[2];
	
	        next(_extends({}, rest, { type: REQUEST }));
	        return promise(client).then(function (result) {
	          return next(_extends({}, rest, { result: result, type: SUCCESS }));
	        }).error(function (error) {
	          return next(_extends({}, rest, { error: error, type: FAILURE }));
	        })['catch'](function (error) {
	          console.error('MIDDLEWARE ERROR:', error);
	          next(_extends({}, rest, { error: error, type: FAILURE }));
	        });
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1054:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(17)['default'];
	
	exports.__esModule = true;
	exports['default'] = urlMiddleware;
	
	function urlMiddleware(history) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch;
	    var getState = _ref.getState;
	
	    return function (next) {
	      return function (action) {
	
	        var result = next(action);
	
	        var url = action.url;
	
	        var rest = _objectWithoutProperties(action, ['url']);
	
	        if (url) {
	          if (typeof url === 'function') {
	            history.pushState(null, url(getState()));
	          } else {
	            history.pushState(null, url);
	          }
	        }
	
	        return result;
	      };
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1055:
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reducer;
	var initialState = {};
	
	function reducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		return state;
	}
	
	module.exports = exports["default"];

/***/ },

/***/ 1056:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.reducer = reducer;
	
	var _reactisDatagrid = __webpack_require__(66);
	
	var CLOSE = '@@Tab/Close';
	
	function reducer(state, action) {
		switch (action.type) {
			case CLOSE:
				return state['delete'](action.id);
	
			default:
				return _reactisDatagrid.reducer(state, action);
		}
	}

/***/ },

/***/ 1057:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.reducer = reducer;
	
	var _reactisForms = __webpack_require__(23);
	
	var CLOSE = '@@Tab/Close';
	
	function reducer(state, action) {
		switch (action.type) {
			case CLOSE:
				return state['delete']('tab_' + action.id);
	
			default:
				return _reactisForms.reducer(state, action);
		}
	}

/***/ },

/***/ 1058:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	exports.__esModule = true;
	exports['default'] = reducer;
	exports.setStatus = setStatus;
	var SET_STATUS = '@@invoice/SET_STATUS';
	var SET_STATUS_SUCCESS = '@@invoice/SET_STATUS_SUCCESS';
	var SET_STATUS_FAIL = '@@invoice/SET_STATUS_FAIL';
	
	var initialState = {
	  pending: false
	};
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case SET_STATUS:
	      return _extends({}, state, {
	        pending: true
	      });
	    case SET_STATUS_SUCCESS:
	      return _extends({}, state, {
	        pending: false
	      });
	    case SET_STATUS_FAIL:
	      return _extends({}, state, {
	        pending: false
	      });
	
	    default:
	      return state;
	  }
	}
	
	function setStatus(qa, status) {
	  return {
	    types: [SET_STATUS, SET_STATUS_SUCCESS, SET_STATUS_FAIL],
	    promise: function promise(client) {
	      return client.call('invoice.setStatus', { qa: qa, status: status }, { progress: true });
	    }
	  };
	}

/***/ },

/***/ 1059:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	exports['default'] = reducer;
	exports.openPage = openPage;
	
	var _immutable = __webpack_require__(19);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _url = __webpack_require__(1121);
	
	var _url2 = _interopRequireDefault(_url);
	
	var OPEN = '@@Navi/openPage';
	
	var naviUrl = function naviUrl(state) {
		var params = state.navi.params;
		if (params.filter) {
			params.filter = JSON.stringify(params.filter);
		}
		var s = _url2['default'].format({
			pathname: '/' + state.navi.page,
			query: params
		});
		return s;
	};
	
	var initialState = {
		page: 'firm',
		params: {}
	};
	
	function reducer() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
		var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		switch (action.type) {
	
			case OPEN:
				var navi = {
					page: action.page,
					params: action.params
				};
				return _extends({}, navi);
	
			default:
				return state;
		}
	}
	
	function openPage(page) {
		var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		return {
			type: OPEN,
			page: page,
			params: params,
			url: naviUrl
		};
	}

/***/ },

/***/ 1060:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(27);
	
	var _auth = __webpack_require__(130);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _tabs = __webpack_require__(511);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _navi = __webpack_require__(1059);
	
	var _navi2 = _interopRequireDefault(_navi);
	
	var _profile = __webpack_require__(510);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _datagridDefaultState = __webpack_require__(1055);
	
	var _datagridDefaultState2 = _interopRequireDefault(_datagridDefaultState);
	
	var _reactisModal = __webpack_require__(29);
	
	var _datagridTab = __webpack_require__(1056);
	
	var _formTab = __webpack_require__(1057);
	
	exports['default'] = _redux.combineReducers({
		auth: _auth2['default'],
		navi: _navi2['default'],
		forms: _formTab.reducer,
		datagrids: _datagridTab.reducer,
		tabs: _tabs2['default'],
		modals: _reactisModal.reducer,
		profile: _profile2['default'],
		datagridDefaultState: _datagridDefaultState2['default']
	});
	module.exports = exports['default'];

/***/ },

/***/ 1061:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(460);
	
	var _reduxModulesAuth = __webpack_require__(130);
	
	var _containersAppApp = __webpack_require__(977);
	
	var _containersAppApp2 = _interopRequireDefault(_containersAppApp);
	
	var _containersAppAppWithMenu = __webpack_require__(978);
	
	var _containersAppAppWithMenu2 = _interopRequireDefault(_containersAppAppWithMenu);
	
	var _containersLoginLogin = __webpack_require__(989);
	
	var _containersLoginLogin2 = _interopRequireDefault(_containersLoginLogin);
	
	var _containersNotFound = __webpack_require__(990);
	
	var _containersNotFound2 = _interopRequireDefault(_containersNotFound);
	
	var _containersEmailTemplatePage = __webpack_require__(984);
	
	var _containersEmailTemplatePage2 = _interopRequireDefault(_containersEmailTemplatePage);
	
	var _containersUserPage = __webpack_require__(999);
	
	var _containersUserPage2 = _interopRequireDefault(_containersUserPage);
	
	var _containersClientPage = __webpack_require__(981);
	
	var _containersClientPage2 = _interopRequireDefault(_containersClientPage);
	
	var _containersTicketPage = __webpack_require__(996);
	
	var _containersTicketPage2 = _interopRequireDefault(_containersTicketPage);
	
	var _containersInvoicePage = __webpack_require__(988);
	
	var _containersInvoicePage2 = _interopRequireDefault(_containersInvoicePage);
	
	var _containersProjectPage = __webpack_require__(993);
	
	var _containersProjectPage2 = _interopRequireDefault(_containersProjectPage);
	
	var _containersUserProfile = __webpack_require__(1000);
	
	var _containersUserProfile2 = _interopRequireDefault(_containersUserProfile);
	
	exports['default'] = function (store) {
	
		var requireLogin = function requireLogin(nextState, replaceState, cb) {
			function checkAuth() {
				var _store$getState = store.getState();
	
				var isLoggedIn = _store$getState.auth.isLoggedIn;
	
				if (!isLoggedIn) {
					replaceState(null, '/login?backlink=' + encodeURIComponent(nextState.location.pathname + nextState.location.search));
				}
				cb();
			}
			checkAuth();
		};
	
		return _react2['default'].createElement(
			_reactRouter.Route,
			{ path: '/', component: _containersAppApp2['default'] },
			_react2['default'].createElement(
				_reactRouter.Route,
				{ onEnter: requireLogin, component: _containersAppAppWithMenu2['default'] },
				_react2['default'].createElement(_reactRouter.IndexRoute, { name: 'ticket', component: _containersTicketPage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/ticket(/:id)', name: 'ticket', component: _containersTicketPage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/invoice(/:id)', name: 'invoice', component: _containersInvoicePage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/client(/:id)', name: 'client', component: _containersClientPage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/project(/:id)', name: 'project', component: _containersProjectPage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/user(/:id)', name: 'user', menu: 'setting', component: _containersUserPage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/emailtemplate(/:id)', name: 'emailtemplate', menu: 'setting', component: _containersEmailTemplatePage2['default'] }),
				_react2['default'].createElement(_reactRouter.Route, { path: '/profile', name: 'profile', component: _containersUserProfile2['default'] })
			),
			_react2['default'].createElement(_reactRouter.Route, { path: '/login', name: 'login', component: _containersLoginLogin2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '*', component: _containersNotFound2['default'], status: 404 })
		);
	};
	
	module.exports = exports['default'];

/***/ },

/***/ 1062:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var request = __webpack_require__(1065);
	
	var JsonRpc = function JsonRpc(endpoint, namespace) {
		this.endpoint = endpoint;
		this.namespace = namespace;
	};
	
	JsonRpc.prototype.call = function (method, args, callback) {
		var jsonRequest = this.buildRequest(method, { params: args });
		request.post(this.endpoint).type('application/json').send(jsonRequest).end(function (err, res) {
			try {
				var response = JSON.parse(res.text);
				if (response.error) {
					callback(response.error, null);
				} else {
					callback(null, response.result);
				}
			} catch (e) {
				callback(res.text, null);
			}
		});
	};
	
	JsonRpc.prototype.buildRequest = function (method, options) {
		if (options === undefined) {
			options = { id: 1 };
		}
		if (options.id === undefined) {
			options.id = 1;
		}
		// Validate method arguments
		//this._validateRequestMethod(method);
		//this._validateRequestParams(options.params);
		//this._validateRequestCallbacks(options.success, options.error);
		var dataObj = {
			jsonrpc: '2.0',
			method: this.namespace ? this.namespace + '.' + method : method,
			id: options.id
		};
		if (options.params !== undefined) {
			dataObj.params = options.params;
			/*Object.keys(dataObj.params).forEach((key) => {
	  	console.log(key);
	  	console.log(dataObj.params[key]);
	  	if (typeof dataObj.params[key] == 'undefined') {
	  		dataObj.params[key] = 1;
	  	}
	  });*/
		}
		return dataObj;
	};
	
	module.exports = JsonRpc;

/***/ },

/***/ 1063:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(2)['default'];
	
	exports.__esModule = true;
	
	var _uuid = __webpack_require__(171);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var response = function response(request, callback, data) {
		this.socket.removeAllListeners('response_' + request);
		var response = JSON.parse(data);
		if (response.error) {
			if (false) {
				console.log('API Error', response.error);
			}
			callback(response.error, null);
		} else {
			try {
				var json = JSON.parse(data);
				if (json) {
					if (false) {
						console.log('API Response', json);
					}
					callback(null, json.result);
				}
			} catch (e) {
				if (false) {
					console.log('API Error', data);
				}
				callback(data, null);
			}
		}
	};
	
	var WebsocketsRpc = function WebsocketsRpc(socket) {
		this.socket = socket;
	};
	
	WebsocketsRpc.prototype.call = function (method, args, callback) {
		var jsonRequest = this.buildRequest(method, { params: args });
		var rid = _uuid2['default'].v4();
		var data = { request: rid, json: jsonRequest };
		this.socket.on('response_' + rid, response.bind(this, rid, callback));
		this.socket.emit('api', data);
		if (false) {
			console.log('API Request', data);
		}
	};
	
	WebsocketsRpc.prototype.buildRequest = function (method, options) {
		if (options === undefined) {
			options = { id: 1 };
		}
		if (options.id === undefined) {
			options.id = 1;
		}
		var dataObj = {
			jsonrpc: '2.0',
			method: method,
			id: options.id
		};
		if (options.params !== undefined) {
			dataObj.params = options.params;
		}
		return dataObj;
	};
	
	exports['default'] = WebsocketsRpc;
	module.exports = exports['default'];

/***/ },

/***/ 1064:
/***/ function(module, exports) {

	// Create a nice client unique enough id.
	// https://github.com/google/closure-library/blob/2012c5372fdb02ce9531cf4b2561b05e3ce2ab39/closure/goog/string/string.js#L1183
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getRandomString;
	
	function getRandomString() {
	    var x = 2147483648;
	    return Math.floor(Math.random() * x).toString(36) + Math.abs(Math.floor(Math.random() * x) ^ Date.now()).toString(36);
	}
	
	module.exports = exports["default"];

/***/ },

/***/ 1126:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


/** WEBPACK FOOTER **
 ** main.js
 **/